<template>
  <v-row class="service-photos" dense v-viewer="viewer_options">
    <v-col v-if="app_mode === 'advanced' || (app_mode === 'default' && getOrganizationParameter('EXTRA_FIELDS_RS_TURBO'))" cols="8" class="mt-4">
      <v-dialog
        ref="dialogdeadline"
        v-model="service_deadline.date_modal"
        :return-value.sync="service_deadline.selected_date"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="service_deadline.formated_date"
            :disabled="status === 'finished' || status === 'canceled'"
            label="Previsão de entrega"
            readonly
            outlined
            hide-details
            @blur="date = parseDate(service_deadline.formated_date)"
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>

        <div style="display: flex">
          <v-date-picker
            v-model="service_deadline.selected_date"
            :style="{ display: service_deadline.date_step === 0 ? '' : 'none' }"
            locale="pt-br"
            color="#48B38B"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="service_deadline.date_modal = false"> Cancelar </v-btn>
            <v-btn text color="primary" @click="service_deadline.date_step = 1"> Continuar </v-btn>
          </v-date-picker>

          <v-time-picker
            v-model="service_deadline.selected_time"
            :style="{ display: service_deadline.date_step === 1 ? '' : 'none' }"
            format="24hr"
            locale="pt-br"
            color="#48B38B"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="service_deadline.date_step = 0"> Voltar </v-btn>
            <v-btn text color="primary" @click="updateForecastDate(service_deadline.selected_date, service_deadline.selected_time)"> Salvar </v-btn>
          </v-time-picker>
        </div>
      </v-dialog>
    </v-col>
    <v-col v-if="app_mode === 'advanced' || (app_mode === 'default' && getOrganizationParameter('EXTRA_FIELDS_RS_TURBO'))" cols="4" class="mt-4">
      <v-text-field
        ref="vehicleKilometer"
        v-model="vehicle_kilometer"
        @input="formatKilometragem"
        v-debounce:1s="saveVehicleKilometer"
        :disabled="status === 'finished' || status === 'canceled'"
        label="Kilometragem"
        small
        outlined
        hide-details
      ></v-text-field>
    </v-col>

    <div style="width: 100%">
      <div v-if="service_order_pending_photos.length > 0" class="pending-photos">
        <h3 class="pp-header">Sincronização pendente</h3>
        <div v-for="pendingMedia in service_order_pending_photos" :key="pendingMedia.id" class="pp-media">
          <v-progress-linear
            v-if="pendingMedia.loading"
            style="top: 6px; position: relative"
            :indeterminate="true"
            color="teal"
            absolute
            top
          ></v-progress-linear>
          <v-icon @click="confirmDeleteMediaBackup(pendingMedia.id)" v-if="!pendingMedia.loading" color="red" class="remove-image"
            >mdi-trash-can</v-icon
          >
          <v-icon @click="resyncMediaBackup(pendingMedia)" v-if="!pendingMedia.loading" color="green" class="resync-image">mdi-sync</v-icon>
          <v-icon @click="downloadPendingMedia(pendingMedia)" v-if="!pendingMedia.loading" color="blue" class="download-image">mdi-download</v-icon>
          <div v-if="pendingMedia.media.type?.includes('video/')" style="overflow: hidden; position: inherit">
            <video width="100%" height="193px" controls style="border-radius: 5px; background-color: #000">
              <source :src="pendingMedia.photo_url" type="video/mp4" />
            </video>
          </div>
          <v-img v-else :src="pendingMedia.photo_url" class="align-end" height="250px"></v-img>
        </div>
      </div>
    </div>

    <div class="photos-container">
      <div class="ml-1 mt-2 panel-title">
        <h3>Seções de fotos e vídeos</h3>
      </div>

      <v-col v-if="loading.length > 0">
        <div class="uploading-photos mt-0">NÃO DESLIGUE A TELA E NÃO FECHE O APLICATIVO</div>
      </v-col>

      <div class="photos-grid">
        <v-expansion-panels v-model="openSectionPanels" multiple flat>
          <MediaSection
            v-for="section in activeSections"
            :key="section.tag"
            :section="section"
            :orders-loading="ordersLoading"
            @refresh-data="organizeMediasBySections"
            @upload-file="uploadMedia"
            @order-loading="addOrderLoading"
          />
        </v-expansion-panels>

        <div class="add-section" @click="modalAddSection.isOpen = true">ADICIONAR SEÇÃO</div>
      </div>
    </div>

    <!--
    <v-col cols="12">
      <h3 class="my-2 mt-2">Fotos e videos</h3>

      <div v-if="uploadQueue.hasPendingUploads() && parameterShowUploadQueueStatus" class="upload-queue-status">
        <h3 class="uqs-header">Uploads em andamento</h3>
        <div class="uqs-info">
          <v-chip small color="blue" text-color="white" class="mr-2">
            <v-icon left small>mdi-upload</v-icon>
            Ativos: {{ uploadQueue.getStats().activeUploads }}
          </v-chip>
          <v-chip small color="orange" text-color="white">
            <v-icon left small>mdi-refresh</v-icon>
            Tentativa: {{ uploadQueue.getStats().retryQueue }}
          </v-chip>
        </div>
        <div v-for="activeUpload in uploadQueue.getActiveUploads()" :key="activeUpload.tag" class="uqs-upload">
          <div class="uqs-upload-info">git
            <span class="uqs-tag">{{ activeUpload.tag }}</span>
            <span class="uqs-status">{{ activeUpload.status }}</span>
          </div>
          <v-progress-linear :indeterminate="true" color="blue" height="4"></v-progress-linear>
        </div>
        <div v-for="retryUpload in uploadQueue.getRetryQueue()" :key="retryUpload.tag" class="uqs-retry">
          <div class="uqs-retry-info">
            <span class="uqs-tag">{{ retryUpload.tag }}</span>
            <span class="uqs-retry-count">Tentativa {{ retryUpload.retryCount }}/5</span>
          </div>
          <div class="uqs-retry-time" v-if="retryUpload.nextRetryTime > Date.now()">
            Próxima tentativa em {{ Math.ceil((retryUpload.nextRetryTime - Date.now()) / 1000) }}s
          </div>
          <div class="uqs-retry-time" v-else>Processando...</div>
        </div>
      </div>
      <div class="checklists-tabs mb-4 mt-1">
        <div class="tab-switch left text-center">
          <div class="tab" :class="{ active: activeTabPhotosVideos === 0 }" @click="switchTabPhotosVideos(0)">Serviço</div>
          <div class="tab" :class="{ active: activeTabPhotosVideos === 1 }" @click="switchTabPhotosVideos(1)">Avarias</div>
        </div>
      </div>
      <v-tabs-items v-model="activeTabPhotosVideos">
        <v-tab-item>
          <div v-if="status !== 'finished' && status !== 'canceled' && service_order_pending_photos.length === 0" class="box">
            <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
              <div @click="openAlternativeTakePhoto('service_medias')" class="add">
                <v-icon size="40">mdi-camera</v-icon>
              </div>
            </div>
            <div v-else>
              <input
                ref="service_medias"
                @change="onFileChange($event, 'service_medias')"
                accept="image/*,video/mp4,.mp4,.heic,.heif"
                type="file"
                class="input-upload"
                multiple
              />
              <div class="add">
                <v-icon size="40">mdi-camera</v-icon>
              </div>
            </div>
          </div>
          <div v-if="loading.length > 0" class="uploading-photos">NÃO DESLIGUE A TELA E NÃO FECHE O APLICATIVO</div>
          <v-row dense class="mt-2" v-for="service_media in service_medias" :key="service_media.first.photo_url">
            <v-col cols="6">
              <v-icon
                v-if="!getStatus('service_medias_' + service_media.order) && status !== 'finished' && status !== 'canceled' && service_media.first.id"
                @click="confirmDeleteMedia('service_medias', service_media.order)"
                color="red"
                class="remove-image"
                >mdi-trash-can</v-icon
              >
              <div
                v-if="!getStatus('service_medias_' + service_media.order) && service_media.first.id"
                @click="handleEditMediaObservation(service_media.first)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <v-progress-linear
                v-if="service_media.first.type?.includes('video/') && getStatus('service_medias_' + service_media.order)"
                style="top: 6px; position: relative"
                :indeterminate="true"
                color="teal"
                absolute
                top
              ></v-progress-linear>
              <div v-if="service_media.first.type?.includes('video/')" style="overflow: hidden; position: inherit">
                <video width="100%" height="193px" controls style="border-radius: 5px; background-color: #000">
                  <source :src="service_media.first.photo_url" type="video/mp4" />
                </video>
                <div v-if="service_media.first.created_at" class="image-info">
                  {{ new Date(service_media.first.created_at).toLocaleDateString() }} às
                  {{ new Date(service_media.first.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }}
                </div>
              </div>
              <div v-else>
                <img v-if="!service_media.first.type?.includes('video/')" class="viewer-preview-helper" :original="service_media.first.photo_url" />
                <v-img :src="getThumborImage(service_media.first)" class="align-end" height="200px">
                  <v-progress-linear
                    v-if="getStatus('service_medias_' + service_media.order)"
                    :indeterminate="true"
                    color="teal"
                    absolute
                    top
                  ></v-progress-linear>
                  <div v-if="service_media.first.created_at" class="image-info">
                    {{ new Date(service_media.first.created_at).toLocaleDateString() }} às
                    {{ new Date(service_media.first.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }}
                  </div>
                </v-img>
              </div>
            </v-col>
            <v-col cols="6">
              <v-icon
                v-if="
                  service_media.second &&
                  service_media.second.id &&
                  !getStatus('service_medias_' + service_media.order + '_second') &&
                  status !== 'finished' &&
                  status !== 'canceled'
                "
                @click="confirmDeleteMedia('service_medias', service_media.order, true)"
                color="red"
                class="remove-image"
                >mdi-trash-can</v-icon
              >
              <div
                v-if="service_media.second && service_media.second.id && !getStatus('service_medias_' + service_media.order + '_second')"
                @click="handleEditMediaObservation(service_media.second)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div class="box h-center">
                <div v-if="service_media.second && service_media.second.photo_url">
                  <v-progress-linear
                    v-if="service_media.second.type?.includes('video/') && getStatus('service_medias_' + service_media.order + '_second')"
                    style="top: -6px"
                    :indeterminate="true"
                    color="teal"
                    absolute
                    top
                  ></v-progress-linear>
                  <div v-if="service_media.second.type?.includes('video/')" style="overflow: hidden; position: inherit">
                    <video
                      v-if="service_media.second.type?.includes('video/')"
                      width="100%"
                      height="193px"
                      controls
                      style="border-radius: 5px; background-color: #000"
                    >
                      <source :src="service_media.second.photo_url" type="video/mp4" />
                    </video>
                    <div v-if="service_media.second.created_at" class="image-info">
                      {{ new Date(service_media.second.created_at).toLocaleDateString() }} às
                      {{ new Date(service_media.second.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }}
                    </div>
                  </div>
                  <div v-else>
                    <img
                      v-if="!service_media.second.type?.includes('video/')"
                      class="viewer-preview-helper"
                      :original="service_media.second.photo_url"
                    />
                    <v-img :src="getThumborImage(service_media.second)" class="align-end" height="200px">
                      <v-progress-linear
                        v-if="getStatus('service_medias_' + service_media.order + '_second')"
                        :indeterminate="true"
                        color="teal"
                        absolute
                        top
                      ></v-progress-linear>
                      <div v-if="service_media.second.created_at" class="image-info">
                        {{ new Date(service_media.second.created_at).toLocaleDateString() }} às
                        {{ new Date(service_media.second.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }}
                      </div>
                    </v-img>
                  </div>
                </div>
                <div v-else style="height: 100%">
                  <input
                    @change="onFileChange($event, 'service_medias', service_media.order)"
                    accept="image/*,video/mp4,.mp4,.heic,.heif"
                    type="file"
                    class="input-upload"
                  />
                  <div class="add">
                    <v-icon>mdi-camera</v-icon>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <div v-if="status !== 'finished' && status !== 'canceled' && service_order_pending_photos.length === 0" class="box">
            <input
              @change="onFileChange($event, 'breakdowns_medias')"
              accept="image/*,video/mp4,.mp4,.heic,.heif"
              type="file"
              class="input-upload"
              multiple
            />
            <div class="add">
              <v-icon size="40">mdi-camera</v-icon>
            </div>
          </div>
          <v-row dense class="mt-2" v-for="breakdowns_media in breakdowns_medias" :key="breakdowns_media.first.id">
            <v-col cols="12">
              <v-icon
                v-if="
                  !getStatus('breakdowns_medias_' + breakdowns_media.order) &&
                  status !== 'finished' &&
                  status !== 'canceled' &&
                  breakdowns_media.first.id
                "
                @click="confirmDeleteMedia('breakdowns_medias', breakdowns_media.order)"
                color="red"
                class="remove-image"
                >mdi-trash-can</v-icon
              >
              <div
                v-if="!getStatus('breakdowns_medias_' + breakdowns_media.order) && breakdowns_media.first.id"
                @click="handleEditMediaObservation(breakdowns_media.first)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <v-progress-linear
                v-if="breakdowns_media.first.type?.includes('video/') && getStatus('breakdowns_medias_' + breakdowns_media.order)"
                style="top: 6px; position: relative"
                :indeterminate="true"
                color="teal"
                absolute
                top
              ></v-progress-linear>
              <div v-if="breakdowns_media.first.type?.includes('video/')" style="overflow: hidden; position: inherit">
                <video width="100%" height="193px" controls style="border-radius: 5px; background-color: #000">
                  <source :src="breakdowns_media.first.photo_url" type="video/mp4" />
                </video>
                <div v-if="breakdowns_media.first.created_at" class="image-info">
                  {{ new Date(breakdowns_media.first.created_at).toLocaleDateString() }} às
                  {{ new Date(breakdowns_media.first.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }}
                </div>
              </div>
              <div v-else>
                <img
                  v-if="!breakdowns_media.first.type?.includes('video/')"
                  class="viewer-preview-helper"
                  :original="breakdowns_media.first.photo_url"
                />
                <v-img :src="getThumborImage(breakdowns_media.first)" class="align-end" height="200px">
                  <v-progress-linear
                    v-if="getStatus('breakdowns_medias_' + breakdowns_media.order)"
                    :indeterminate="true"
                    color="teal"
                    absolute
                    top
                  ></v-progress-linear>
                  <div v-if="breakdowns_media.first.created_at" class="image-info">
                    {{ new Date(breakdowns_media.first.created_at).toLocaleDateString() }} às
                    {{ new Date(breakdowns_media.first.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) }}
                  </div>
                </v-img>
              </div>
            </v-col>
          </v-row>
          <div style="background-color: rgb(238, 238, 238); padding: 10px; font-size: 13px; text-align: center; border-radius: 6px; margin-top: 10px">
            Fotos e vídeos de avarias não são visiveis por padrão. Para torná-las visíveis no link enviado para o cliente, clique no ícone de lápis de
            cada foto e altere a visibilidade.
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
-->

    <v-col cols="12" class="pb-3">
      <h3 class="my-2 mt-3">Checklist</h3>
      <div class="checklists-tabs mb-0 mt-1">
        <div class="tab-switch left text-center">
          <div class="tab" :class="{ active: activeTabChecklist === 0 }" @click="switchTabChecklist(0)">Entrada</div>
          <div class="tab" :class="{ active: activeTabChecklist === 1 }" @click="switchTabChecklist(1)">Saída</div>
        </div>
      </div>
    </v-col>
    <v-col v-if="loading.length > 0">
      <div class="uploading-photos mt-0">NÃO DESLIGUE A TELA E NÃO FECHE O APLICATIVO</div>
    </v-col>
    <v-tabs-items v-model="activeTabChecklist">
      <v-tab-item>
        <v-row style="width: 100%; margin: 0">
          <v-col cols="12">
            <label v-if="entry_medias.main">
              <div
                v-if="entry_medias.main && !getStatus('entry_medias_main')"
                @click="handleEditMediaObservation(entry_medias.main, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'main')">
                <v-icon
                  v-if="entry_medias.main && !getStatus('entry_medias_main') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.main.original_photo_url" />
              <v-img :src="entry_medias.main.photo_url" class="align-end" height="250px">
                <v-progress-linear v-if="getStatus('entry_medias_main')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.main.created_at" class="image-info">
                  {{ new Date(entry_medias.main.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.main.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_main">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'main')" for="entry_medias_main" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-01')" class="align-end" height="140px" :contain="true">
                    <span>Principal</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.main && entry_medias.main.photo_url) || getStatus('entry_medias_main')"
                  @change="onFileChange($event, 'entry_medias', 'main')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_main" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-01')" class="align-end" height="140px" :contain="true">
                    <span>Principal</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <label v-if="entry_medias.front && entry_medias.front.photo_url">
              <div
                v-if="entry_medias.front && !getStatus('entry_medias_front')"
                @click="handleEditMediaObservation(entry_medias.front, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'front')">
                <v-icon
                  v-if="entry_medias.front && !getStatus('entry_medias_front') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.front.original_photo_url" />
              <v-img :src="entry_medias.front.photo_url" class="align-end" height="140px">
                <v-progress-linear v-if="getStatus('entry_medias_front')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.front.created_at" class="image-info">
                  {{ new Date(entry_medias.front.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.front.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_front">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'front')" for="entry_medias_front" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-02')" class="align-end" height="140px" :contain="true">
                    <span>Frontal</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.front && entry_medias.front.photo_url) || getStatus('entry_medias_front')"
                  @change="onFileChange($event, 'entry_medias', 'front')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_front" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-02')" class="align-end" height="140px" :contain="true">
                    <span>Frontal</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <label v-if="entry_medias.rear && entry_medias.rear.photo_url">
              <div
                v-if="entry_medias.rear && !getStatus('entry_medias_rear')"
                @click="handleEditMediaObservation(entry_medias.rear, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'rear')">
                <v-icon
                  v-if="entry_medias.rear && !getStatus('entry_medias_rear') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.rear.original_photo_url" />
              <v-img :src="entry_medias.rear.photo_url" class="align-end" height="140px">
                <v-progress-linear v-if="getStatus('entry_medias_rear')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.rear.created_at" class="image-info">
                  {{ new Date(entry_medias.rear.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.rear.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_rear">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'rear')" for="entry_medias_rear" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-04')" class="align-end" height="140px" :contain="true">
                    <span>Traseira</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.rear && entry_medias.rear.photo_url) || getStatus('entry_medias_rear')"
                  @change="onFileChange($event, 'entry_medias', 'rear')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_rear" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-04')" class="align-end" height="140px" :contain="true">
                    <span>Traseira</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <label v-if="entry_medias.right">
              <div
                v-if="entry_medias.right && !getStatus('entry_medias_right')"
                @click="handleEditMediaObservation(entry_medias.right, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'right')">
                <v-icon
                  v-if="entry_medias.right && !getStatus('entry_medias_right') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.right.original_photo_url" />
              <v-img :src="entry_medias.right.photo_url" class="align-end" height="140px">
                <v-progress-linear v-if="getStatus('entry_medias_right')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.right.created_at" class="image-info">
                  {{ new Date(entry_medias.right.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.right.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_right">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'right')" for="entry_medias_right" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-03')" class="align-end" height="140px" :contain="true">
                    <span>Direita</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.right && entry_medias.right.photo_url) || getStatus('entry_medias_right')"
                  @change="onFileChange($event, 'entry_medias', 'right')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_right" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-03')" class="align-end" height="140px" :contain="true">
                    <span>Direita</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <label v-if="entry_medias.left">
              <div
                v-if="entry_medias.left && !getStatus('entry_medias_left')"
                @click="handleEditMediaObservation(entry_medias.left, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'left')">
                <v-icon
                  v-if="entry_medias.left && !getStatus('entry_medias_left') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.left.original_photo_url" />
              <v-img :src="entry_medias.left.photo_url" class="align-end" height="140px">
                <v-progress-linear v-if="getStatus('entry_medias_left')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.left.created_at" class="image-info">
                  {{ new Date(entry_medias.left.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.left.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_left">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'left')" for="entry_medias_left" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-05')" class="align-end" height="140px" :contain="true">
                    <span>Esquerda</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.left && entry_medias.left.photo_url) || getStatus('entry_medias_left')"
                  @change="onFileChange($event, 'entry_medias', 'left')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_left" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-05')" class="align-end" height="140px" :contain="true">
                    <span>Esquerda</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <label v-if="entry_medias.panel">
              <div
                v-if="entry_medias.panel && !getStatus('entry_medias_panel')"
                @click="handleEditMediaObservation(entry_medias.panel, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'panel')">
                <v-icon
                  v-if="entry_medias.panel && !getStatus('entry_medias_panel') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.panel.original_photo_url" />
              <v-img :src="entry_medias.panel.photo_url" class="align-end" height="250px">
                <v-progress-linear v-if="getStatus('entry_medias_panel')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.panel.created_at" class="image-info">
                  {{ new Date(entry_medias.panel.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.panel.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_panel">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'panel')" for="entry_medias_panel" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('panel')" class="align-end" height="140px" :contain="true">
                    <span>Painel LIGADO</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.panel && entry_medias.panel.photo_url) || getStatus('entry_medias_panel')"
                  @change="onFileChange($event, 'entry_medias', 'panel')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_panel" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('panel')" class="align-end" height="140px" :contain="true">
                    <span>Painel LIGADO</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <label v-if="entry_medias.chassi">
              <div
                v-if="entry_medias.chassi && !getStatus('entry_medias_chassi')"
                @click="handleEditMediaObservation(entry_medias.chassi, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'chassi')">
                <v-icon
                  v-if="entry_medias.chassi && !getStatus('entry_medias_chassi') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.chassi.original_photo_url" />
              <v-img :src="entry_medias.chassi.photo_url" class="align-end" height="250px">
                <v-progress-linear v-if="getStatus('entry_medias_chassi')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.chassi.created_at" class="image-info">
                  {{ new Date(entry_medias.chassi.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.chassi.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_chassi">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'chassi')" for="entry_medias_chassi" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('chassi')" class="align-end" height="140px" :contain="true">
                    <span>Chassi</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.chassi && entry_medias.chassi.photo_url) || getStatus('entry_medias_chassi')"
                  @change="onFileChange($event, 'entry_medias', 'chassi')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_chassi" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('chassi')" class="align-end" height="140px" :contain="true">
                    <span>Chassi</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <label v-if="entry_medias.motor">
              <div
                v-if="entry_medias.motor && !getStatus('entry_medias_motor')"
                @click="handleEditMediaObservation(entry_medias.motor, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'motor')">
                <v-icon
                  v-if="entry_medias.motor && !getStatus('entry_medias_motor') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.motor.original_photo_url" />
              <v-img :src="entry_medias.motor.photo_url" class="align-end" height="250px">
                <v-progress-linear v-if="getStatus('entry_medias_motor')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.motor.created_at" class="image-info">
                  {{ new Date(entry_medias.motor.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.motor.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_motor">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'motor')" for="entry_medias_motor" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                      border: 1px solid #c3c3c3;
                      border-radius: 4px;
                    "
                  >
                    <img style="opacity: 0.6" :src="getThumbnail('motor')" class="align-end" height="140px" contain />

                    <span>Motor</span>
                  </div>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.motor && entry_medias.motor.photo_url) || getStatus('entry_medias_motor')"
                  @change="onFileChange($event, 'entry_medias', 'motor')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_motor" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                      border: 1px solid #c3c3c3;
                      border-radius: 4px;
                    "
                  >
                    <img style="opacity: 0.6" :src="getThumbnail('motor')" class="align-end" height="140px" contain />

                    <span>Motor</span>
                  </div>
                </label>
              </div>
            </div>
          </v-col>

          <v-col cols="12" class="mt-2">
            <v-btn
              @click="reprocessPlate()"
              :disabled="!entry_medias.rear || status === 'finished' || status === 'canceled'"
              color="primary"
              class="mb-1"
              style="width: 49%"
              large
              depressed
            >
              <v-icon class="pr-3" size="20px">mdi-car-connected</v-icon> Reprocessar
            </v-btn>
            <v-btn
              @click="type_plate_modal.opened = true"
              :disabled="!entry_medias.rear || status === 'finished' || status === 'canceled'"
              color="primary"
              class="mb-1"
              style="width: 49%; margin-left: 2%"
              large
              depressed
            >
              <v-icon class="pr-3" size="20px">mdi-car-info</v-icon> Digitar
            </v-btn>
            <small v-if="entry_medias.rear"
              >* Lembre-se de tirar sempre uma foto <b>TRASEIRA</b> em que somente a placa do veículo fique bem visivel</small
            >
            <small v-else>* Tire uma foto <b>traseira</b> para habilitar o re-processamento</small>
          </v-col>
          <v-col v-if="!isMotorcycle && !isTractor && !isTruck" cols="12">
            <h3 class="mx-2 mt-4 ml-0">Chave anti-furto da roda e estepe</h3>
          </v-col>
          <v-col v-if="!isMotorcycle && !isTractor && !isTruck" cols="6">
            <label v-if="entry_medias.secret">
              <div
                v-if="entry_medias.secret && !getStatus('entry_medias_secret')"
                @click="handleEditMediaObservation(entry_medias.secret, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'secret')">
                <v-icon
                  v-if="entry_medias.secret && !getStatus('entry_medias_secret') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.secret.original_photo_url" />
              <v-img :src="entry_medias.secret.photo_url" class="align-end" height="250px">
                <v-progress-linear v-if="getStatus('entry_medias_secret')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.secret.created_at" class="image-info">
                  {{ new Date(entry_medias.secret.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.secret.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_secret">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'secret')" for="entry_medias_secret" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <div class="secret-image">
                    <img :src="getThumbnail('secret')" />
                  </div>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.secret && entry_medias.secret.photo_url) || getStatus('entry_medias_secret')"
                  @change="onFileChange($event, 'entry_medias', 'secret')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_secret" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <div class="secret-image">
                    <img :src="getThumbnail('secret')" />
                  </div>
                </label>
              </div>
            </div>
          </v-col>
          <v-col v-if="!isMotorcycle && !isTractor && !isTruck" cols="6">
            <label v-if="entry_medias.step">
              <div
                v-if="entry_medias.step && !getStatus('entry_medias_step')"
                @click="handleEditMediaObservation(entry_medias.step, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('entry_medias', 'step')">
                <v-icon
                  v-if="entry_medias.step && !getStatus('entry_medias_step') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="entry_medias.step.original_photo_url" />
              <v-img :src="entry_medias.step.photo_url" class="align-end" height="250px">
                <v-progress-linear v-if="getStatus('entry_medias_step')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="entry_medias.step.created_at" class="image-info">
                  {{ new Date(entry_medias.step.created_at).toLocaleDateString() }} às
                  {{ new Date(entry_medias.step.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_step">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('entry_medias', 'step')" for="entry_medias_step" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <div class="step-image">
                    <img :src="getThumbnail('step')" />
                  </div>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(entry_medias.step && entry_medias.step.photo_url) || getStatus('entry_medias_step')"
                  @change="onFileChange($event, 'entry_medias', 'step')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="entry_medias_step" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <div class="step-image">
                    <img :src="getThumbnail('step')" />
                  </div>
                </label>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <div class="check-torque">
          <div style="overflow: hidden">
            <v-checkbox
              v-model="wheel_torque_status"
              @click="handleWheelTorqueClick"
              style="float: left; padding: 15px 10px"
              class="ma-0"
              hide-details
            ></v-checkbox>
            <div v-if="wheel_torque_status" style="float: left; line-height: 22px; padding-top: 5px">
              <h4 class="ma-0">TORQUE DAS RODAS VERIFICADO</h4>
              <small v-if="activeWheelTorque">{{ getWheelTorqueUserInfo(activeWheelTorque) }}</small>
            </div>
            <div v-else style="float: left; line-height: 22px; padding-top: 5px">
              <h4 class="ma-0">VERIFIQUE O TORQUE DAS RODAS</h4>
              <small>GARANTA A SEGURANÇA DO CLIENTE</small>
            </div>
          </div>
        </div>
        <v-row style="width: 100%; margin: 0">
          <v-col cols="12">
            <label v-if="leaving_medias.main">
              <div
                v-if="leaving_medias.main && !getStatus('leaving_medias_main')"
                @click="handleEditMediaObservation(leaving_medias.main, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('leaving_medias', 'main')">
                <v-icon
                  v-if="leaving_medias.main && !getStatus('leaving_medias_main') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="leaving_medias.main.original_photo_url" />
              <v-img :src="leaving_medias.main.photo_url" class="align-end" height="250px">
                <v-progress-linear v-if="getStatus('leaving_medias_main')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="leaving_medias.main.created_at" class="image-info">
                  {{ new Date(leaving_medias.main.created_at).toLocaleDateString() }} às
                  {{ new Date(leaving_medias.main.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="leaving_medias_main">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('leaving_medias', 'main')" for="leaving_medias_main" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-01')" class="align-end" height="140px" :contain="true">
                    <span>Principal</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(leaving_medias.main && leaving_medias.main.photo_url) || getStatus('leaving_medias_main')"
                  @change="onFileChange($event, 'leaving_medias', 'main')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="leaving_medias_main" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-01')" class="align-end" height="140px" :contain="true">
                    <span>Principal</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <label v-if="leaving_medias.front && leaving_medias.front.photo_url">
              <div
                v-if="leaving_medias.front && !getStatus('leaving_medias_front')"
                @click="handleEditMediaObservation(leaving_medias.front, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('leaving_medias', 'front')">
                <v-icon
                  v-if="leaving_medias.front && !getStatus('leaving_medias_front') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="leaving_medias.front.original_photo_url" />
              <v-img :src="leaving_medias.front.photo_url" class="align-end" height="140px">
                <v-progress-linear v-if="getStatus('leaving_medias_front')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="leaving_medias.front.created_at" class="image-info">
                  {{ new Date(leaving_medias.front.created_at).toLocaleDateString() }} às
                  {{ new Date(leaving_medias.front.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="leaving_medias_front">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('leaving_medias', 'front')" for="leaving_medias_front" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-02')" class="align-end" height="140px" :contain="true">
                    <span>Frontal</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(leaving_medias.front && leaving_medias.front.photo_url) || getStatus('leaving_medias_front')"
                  @change="onFileChange($event, 'leaving_medias', 'front')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="leaving_medias_front" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-02')" class="align-end" height="140px" :contain="true">
                    <span>Frontal</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <label v-if="leaving_medias.rear && leaving_medias.rear.photo_url">
              <div
                v-if="leaving_medias.rear && !getStatus('leaving_medias_rear')"
                @click="handleEditMediaObservation(leaving_medias.rear, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('leaving_medias', 'rear')">
                <v-icon
                  v-if="leaving_medias.rear && !getStatus('leaving_medias_rear') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="leaving_medias.rear.original_photo_url" />
              <v-img :src="leaving_medias.rear.photo_url" class="align-end" height="140px">
                <v-progress-linear v-if="getStatus('leaving_medias_rear')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="leaving_medias.rear.created_at" class="image-info">
                  {{ new Date(leaving_medias.rear.created_at).toLocaleDateString() }} às
                  {{ new Date(leaving_medias.rear.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="leaving_medias_rear">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('leaving_medias', 'rear')" for="leaving_medias_rear" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-04')" class="align-end" height="140px" :contain="true">
                    <span>Traseira</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(leaving_medias.rear && leaving_medias.rear.photo_url) || getStatus('leaving_medias_rear')"
                  @change="onFileChange($event, 'leaving_medias', 'rear')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="leaving_medias_rear" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-04')" class="align-end" height="140px" :contain="true">
                    <span>Traseira</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <label v-if="leaving_medias.right">
              <div
                v-if="leaving_medias.right && !getStatus('leaving_medias_right')"
                @click="handleEditMediaObservation(leaving_medias.right, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('leaving_medias', 'right')">
                <v-icon
                  v-if="leaving_medias.right && !getStatus('leaving_medias_right') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="leaving_medias.right.original_photo_url" />
              <v-img :src="leaving_medias.right.photo_url" class="align-end" height="140px">
                <v-progress-linear v-if="getStatus('leaving_medias_right')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="leaving_medias.right.created_at" class="image-info">
                  {{ new Date(leaving_medias.right.created_at).toLocaleDateString() }} às
                  {{ new Date(leaving_medias.right.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="leaving_medias_right">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('leaving_medias', 'right')" for="leaving_medias_right" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-03')" class="align-end" height="140px" :contain="true">
                    <span>Direita</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(leaving_medias.right && leaving_medias.right.photo_url) || getStatus('leaving_medias_right')"
                  @change="onFileChange($event, 'leaving_medias', 'right')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="leaving_medias_right" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-03')" class="align-end" height="140px" :contain="true">
                    <span>Direita</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <label v-if="leaving_medias.left">
              <div
                v-if="leaving_medias.left && !getStatus('leaving_medias_left')"
                @click="handleEditMediaObservation(leaving_medias.left, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('leaving_medias', 'left')">
                <v-icon
                  v-if="leaving_medias.left && !getStatus('leaving_medias_left') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="leaving_medias.left.original_photo_url" />
              <v-img :src="leaving_medias.left.photo_url" class="align-end" height="140px">
                <v-progress-linear v-if="getStatus('leaving_medias_left')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="leaving_medias.left.created_at" class="image-info">
                  {{ new Date(leaving_medias.left.created_at).toLocaleDateString() }} às
                  {{ new Date(leaving_medias.left.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="leaving_medias_left">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('leaving_medias', 'left')" for="leaving_medias_left" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-05')" class="align-end" height="140px" :contain="true">
                    <span>Esquerda</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(leaving_medias.left && leaving_medias.left.photo_url) || getStatus('leaving_medias_left')"
                  @change="onFileChange($event, 'leaving_medias', 'left')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="leaving_medias_left" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('photo-05')" class="align-end" height="140px" :contain="true">
                    <span>Esquerda</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <label v-if="leaving_medias.panel">
              <div
                v-if="leaving_medias.panel && !getStatus('leaving_medias_panel')"
                @click="handleEditMediaObservation(leaving_medias.panel, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('leaving_medias', 'panel')">
                <v-icon
                  v-if="leaving_medias.panel && !getStatus('leaving_medias_panel') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="leaving_medias.panel.original_photo_url" />
              <v-img :src="leaving_medias.panel.photo_url" class="align-end" :contain="true">
                <v-progress-linear v-if="getStatus('leaving_medias_panel')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="leaving_medias.panel.created_at" class="image-info">
                  {{ new Date(leaving_medias.panel.created_at).toLocaleDateString() }} às
                  {{ new Date(leaving_medias.panel.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="leaving_medias_panel">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('leaving_medias', 'panel')" for="leaving_medias_panel" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('panel')" class="align-end opacity" height="140px" :contain="true">
                    <span>Painel</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(leaving_medias.panel && leaving_medias.panel.photo_url) || getStatus('leaving_medias_panel')"
                  @change="onFileChange($event, 'leaving_medias', 'panel')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="leaving_medias_panel" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('panel')" class="align-end opacity" height="140px" :contain="true">
                    <span>Painel</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <label v-if="leaving_medias.chassi">
              <div
                v-if="leaving_medias.chassi && !getStatus('leaving_medias_chassi')"
                @click="handleEditMediaObservation(leaving_medias.chassi, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('leaving_medias', 'chassi')">
                <v-icon
                  v-if="leaving_medias.chassi && !getStatus('leaving_medias_chassi') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="leaving_medias.chassi.original_photo_url" />
              <v-img :src="leaving_medias.chassi.photo_url" class="align-end" height="250px">
                <v-progress-linear v-if="getStatus('leaving_medias_chassi')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="leaving_medias.chassi.created_at" class="image-info">
                  {{ new Date(leaving_medias.chassi.created_at).toLocaleDateString() }} às
                  {{ new Date(leaving_medias.chassi.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="leaving_medias_chassi">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('leaving_medias', 'chassi')" for="leaving_medias_chassi" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('chassi')" class="align-end" height="140px" :contain="true">
                    <span>Chassi</span>
                  </v-img>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(leaving_medias.chassi && leaving_medias.chassi.photo_url) || getStatus('leaving_medias_chassi')"
                  @change="onFileChange($event, 'leaving_medias', 'chassi')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="leaving_medias_chassi" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <v-img :src="getThumbnail('chassi')" class="align-end" height="140px" :contain="true">
                    <span>Chassi</span>
                  </v-img>
                </label>
              </div>
            </div>
          </v-col>

          <v-col cols="12">
            <label v-if="leaving_medias.motor">
              <div
                v-if="leaving_medias.motor && !getStatus('leaving_medias_motor')"
                @click="handleEditMediaObservation(leaving_medias.motor, true)"
                class="edit-observations"
              >
                <v-icon color="#3e515f">mdi-pencil</v-icon>
              </div>
              <div @click="confirmDeleteMedia('leaving_medias', 'motor')">
                <v-icon
                  v-if="leaving_medias.motor && !getStatus('leaving_medias_motor') && status !== 'finished' && status !== 'canceled'"
                  color="red"
                  class="remove-image"
                  >mdi-trash-can</v-icon
                >
              </div>
              <img class="viewer-preview-helper" :original="leaving_medias.motor.original_photo_url" />
              <v-img :src="leaving_medias.motor.photo_url" class="align-end" height="250px">
                <v-progress-linear v-if="getStatus('leaving_medias_motor')" :indeterminate="true" color="teal" absolute top></v-progress-linear>
                <div v-if="leaving_medias.motor.created_at" class="image-info">
                  {{ new Date(leaving_medias.motor.created_at).toLocaleDateString() }} às
                  {{ new Date(leaving_medias.motor.created_at).toLocaleTimeString() }}
                </div>
              </v-img>
            </label>
            <div v-else id="entry_medias_motor">
              <div v-if="parameterMediaCameraType && parameterMediaCameraType === 'alternative'">
                <label @click="openAlternativeTakePhoto('leaving_medias', 'motor')" for="leaving_medias_motor" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                      border: 1px solid #c3c3c3;
                      border-radius: 4px;
                    "
                  >
                    <img style="opacity: 0.6" :src="getThumbnail('motor')" class="align-end" height="140px" contain />

                    <span>Motor</span>
                  </div>
                </label>
              </div>
              <div v-else>
                <input
                  :disabled="(leaving_medias.motor && leaving_medias.motor.photo_url) || getStatus('leaving_medias_motor')"
                  @change="onFileChange($event, 'leaving_medias', 'motor')"
                  accept="image/*,.heic,.heif"
                  type="file"
                  class="input-upload"
                />
                <label for="leaving_medias_motor" slot="upload-label" :class="thumbnailPlaceholderContainerClass">
                  <div
                    style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      flex-direction: column;
                      border: 1px solid #c3c3c3;
                      border-radius: 4px;
                    "
                  >
                    <img style="opacity: 0.6" :src="getThumbnail('motor')" class="align-end" height="140px" contain />

                    <span>Motor</span>
                  </div>
                </label>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>
    <v-col v-if="!isOperational" cols="12">
      <h3 class="my-2 mt-2">Anexos</h3>
      <AttachmentsManager
        :attachments="attachments"
        :canAdd="true"
        @rename="handleRenameAttachment"
        @upload="handleUploadAttachment"
        @delete="handleDeleteAttachment"
        @toggle-visibility="handleToggleVisibility"
      />
    </v-col>

    <v-col cols="12">
      <h3 class="my-2 mt-2">Outras ações</h3>
      <v-btn @click="printOS()" :loading="printLoading" outlined color="primary" dark large elevation="0" block>
        <v-icon class="mr-2">mdi-printer</v-icon>
        <span>IMPRIMIR PASTA</span>
      </v-btn>
    </v-col>

    <v-col v-if="service_order_backup_photos?.length" cols="12">
      <v-btn color="primary" elevation="0" depressed block @click="backupPhotosDialog.open = true"> backup de fotos/vídeos </v-btn>
    </v-col>

    <v-dialog v-model="confirm_delete.opened" persistent>
      <v-card class="pb-3">
        <v-card-title class="text-h5"> Deletar a mídia do RS ? </v-card-title>
        <v-card-text>Esta ação só poderá ser desfeita através do suporte técnico.</v-card-text>
        <v-card-actions mb-2>
          <v-btn color="blue-grey darken-1" width="48%" depressed outlined dark @click="confirm_delete.opened = false"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" width="48%" depressed outlined dark @click="deleteMedia()"> Excluir </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="confirm_delete_backup.opened" persistent>
      <v-card class="pb-3">
        <v-card-title class="text-h5"> Excluir este backup ? </v-card-title>
        <v-card-text>Esta ação não poderá ser desfeita, esta mídia não poderá mais ser recuperada.</v-card-text>
        <v-card-actions mb-2>
          <v-btn color="blue-grey darken-1" width="48%" depressed outlined dark @click="confirm_delete_backup.opened = false"> Cancelar </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" width="48%" depressed outlined dark @click="deleteMediaBackup()"> Excluir </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="type_plate_modal.opened" persistent>
      <v-card class="pb-3">
        <v-card-title class="text-h5 pb-5" style="background-color: #eee"> Buscar dados da placa </v-card-title>
        <v-card-text class="mt-6">
          <v-text-field
            v-model="type_plate_modal.plate"
            @keyup="uppercaseVehiclePlate"
            :disabled="type_plate_modal.loading"
            label="Placa do veículo"
            clearable
            maxlength="7"
            outlined
            hide-details
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="mb-2 px-6">
          <v-btn
            :disabled="type_plate_modal.loading"
            color="blue-grey darken-1"
            width="48%"
            outlined
            large
            depressed
            :dark="!type_plate_modal.loading"
            @click="type_plate_modal.opened = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn :loading="type_plate_modal.loading" color="primary" width="48%" large depressed dark @click="typePlate()"> Buscar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-bottom-sheet v-model="isModalRenameAttachmentActive" persistent>
      <div class="bottom-sheet-content">
        <div class="bottom-sheet-header">
          <span class="bottom-sheet-title">Renomear anexo</span>
          <v-btn icon @click="isModalRenameAttachmentActive = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-text-field v-model="attachmentToRename.description" label="Nome do anexo" outlined clearable></v-text-field>
        <v-btn color="primary" block @click="renameAttachment" :disabled="!attachmentToRename.description">Renomear</v-btn>
      </div>
    </v-bottom-sheet>

    <v-dialog v-model="isRemoveAttachmentModalActive" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Remover anexo </v-card-title>
        <v-card-text> Tem certeza que deseja remover este anexo? </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="isRemoveAttachmentModalActive = false"> Cancelar </v-btn>
          <v-btn color="red darken-1" text @click="removeAttachment"> Excluir </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-bottom-sheet v-model="isModalEditObservationsActive" persistent>
      <div class="bottom-sheet-content">
        <div class="bottom-sheet-header">
          <span class="bottom-sheet-title">Editar observações da mídia</span>
          <v-btn icon @click="closeEditObservationsModal()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>

        <div class="mt-5">
          <v-textarea
            height="150px"
            v-model="mediaToEdit.observation"
            label="Observações"
            outlined
            hide-details
            style="width: calc(100% - 35px); float: left"
          ></v-textarea>
          <button
            v-if="status !== 'finished' && status !== 'canceled'"
            @click="recognitionVoice"
            :class="{ 'voice-recognition': true, recording: mediaToEdit.isRecognizing }"
            style="
              cursor: pointer;
              width: 30px;
              height: 150px;
              margin-left: 5px;
              text-align: center;
              border: 1px dashed rgba(0, 0, 0, 0.4);
              border-radius: 6px;
            "
          >
            <div :key="mediaToEdit.isRecognizing">
              <div v-if="mediaToEdit.isRecognizing">
                <v-icon size="28" color="#fff">mdi-microphone</v-icon>
              </div>
              <div v-else>
                <v-icon size="28">mdi-microphone</v-icon>
              </div>
            </div>
          </button>
        </div>

        <RecognitionVoiceService v-if="speechToText.isRecognizing" @recognized-voice="handleSpeechRecognitionResult" @cancel="cancelRecognizeVoice" />

        <div v-if="mediaToEdit.updated_by_user" class="mt-2 mb-4">
          <small
            >Alterado pela última vez por {{ handleObservation(mediaToEdit.updated_by_user) }} em
            {{ new Date(mediaToEdit.updated_at).toLocaleDateString() }} às {{ new Date(mediaToEdit.updated_at).toLocaleTimeString() }}</small
          >
        </div>

        <v-switch
          v-if="!mediaToEdit.tag?.includes('entry_medias') && !showHideMediaBtn"
          v-model="mediaToEdit.visible"
          label="Mídia visível para o cliente"
          color="primary"
        ></v-switch>
        <v-btn class="mt-2" color="primary" block @click="editMediaObservation" elevation="0">Salvar</v-btn>
      </div>
    </v-bottom-sheet>

    <ModalManageClient :isActive="new_client.dialog" @close="closeNewClientDialog" />

    <PlateRecognitionDialog
      ref="plateRecognitionDialog"
      :open="plateRecognitionDialog.open"
      :media="plateRecognitionDialog.media"
      @newClientCallback="newClientCallback"
      @close="closePlateRecognition"
      @plateSelected="handlePlateSelected"
    />

    <ModalBackupPhotos
      :dialog="backupPhotosDialog"
      @close="closeModalBackupPhotos"
      @delete-photo="deletePhotoInBackup"
      @resync-photo="resyncPhotoInBackup"
    />

    <TakePhotoDialog
      v-if="TakePhotoDialog.modal"
      :component="TakePhotoDialog.component"
      @media-captured="mediaCapturedAlternative"
      @close="closeAlternativeTakePhoto"
    />

    <ModalAddSection
      :is-active="modalAddSection.isOpen"
      :loading="modalAddSection.loading"
      @close="modalAddSection.isOpen = false"
      @save="saveModalAddSection"
    />
  </v-row>
</template>

<script>
import 'viewerjs/dist/viewer.css';
import { directive as viewer } from 'v-viewer';
// eslint-disable-next-line import/no-extraneous-dependencies
import heic2any from 'heic2any';
import dayjs from 'dayjs';
import api from '@/plugins/axios';

import Thumbor from 'thumbor-js-url-builder';
import dexieDB from '@/services/dexieService';
import UploadQueueManager from '@/services/UploadQueueManager';

import ServiceOrderPhotoService from '@/services/api/serviceOrderPhoto';
import ServiceOrderAttachmentService from '@/services/api/serviceOrderAttachment';
import RecognitionVoiceService from '@/components/Common/RecognitionVoiceService';
import { startLocationTracking, appendMetadataToFormData, getMetadataForJson } from '@/services/mediaMetadata';

import AttachmentsManager from '@/components/Budget/AttachmentsManager';
import ModalManageClient from './Dialogs/ModalManageClient';
import PlateRecognitionDialog from './Dialogs/PlateRecognitionDialog';
import ModalBackupPhotos from './Dialogs/ModalBackupPhotos';
import TakePhotoDialog from './Dialogs/TakePhotoDialog';
import MediaSection from './Photos/MediaSection';
import ModalAddSection from './Photos/ModalAddSection';

const SECTION_CONFIGS = [
  {
    tag: 'service_medias',
    description: 'SERVIÇO',
    supportsPairs: true
  },
  {
    tag: 'breakdowns_medias',
    description: 'AVARIAS',
    supportsPairs: false
  }
];

export default {
  directives: {
    viewer: viewer({
      debug: false
    })
  },
  components: {
    ModalManageClient,
    AttachmentsManager,
    PlateRecognitionDialog,
    RecognitionVoiceService,
    ModalBackupPhotos,
    TakePhotoDialog,
    MediaSection,
    ModalAddSection
  },
  props: {
    isNew: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: [],
    service_order_pending_photos: [],
    service_order_backup_photos: [],
    currentServiceOrderId: null,
    uploadQueue: new UploadQueueManager(),
    isModalEditObservationsActive: false,
    isModalRenameAttachmentActive: false,
    isRemoveAttachmentModalActive: false,
    mediaToEdit: {
      observation: '',
      recognition: null,
      isRecognizing: false
    },
    showHideMediaBtn: false,
    attachments: [],
    entry_order: 0,
    breakdowns_order: 0,
    lastProcessedServiceId: null,
    entry_medias: {
      main: null,
      front: null,
      rear: null,
      right: null,
      left: null,
      panel: null,
      secret: null,
      step: null,
      chassi: null,
      motor: null
    },
    leaving_medias: {
      main: null,
      front: null,
      rear: null,
      right: null,
      left: null,
      panel: null,
      chassi: null,
      motor: null
    },
    confirm_delete: {
      id: null,
      opened: false,
      component: null,
      second: null,
      index: null
    },
    new_client: {
      dialog: false,
      vehicle_plate: null
    },
    init_interval: null,
    viewer_options: {
      url: 'original',
      button: true,
      navbar: true,
      title: false,
      toolbar: false,
      tooltip: true,
      movable: true,
      zoomable: true,
      rotatable: true,
      scalable: true,
      transition: true,
      fullscreen: true,
      keyboard: true
    },
    vehicle_kilometer: null,
    service_deadline: {
      date_modal: false,
      date_step: 0,
      selected_date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      selected_time: null,
      formated_date: new Date().toLocaleDateString()
    },
    attachmentToRename: {
      id: null,
      description: null
    },
    activeTabChecklist: 0,
    activeTabPhotosVideos: 0,
    wheel_torque_status: false,
    resumable: null,
    confirm_delete_backup: {
      opened: false,
      id: null
    },
    printLoading: false,
    type_plate_modal: {
      loading: false,
      opened: false,
      plate: null
    },
    isOperational: false,
    isMultipleUpload: true,
    speechToText: {
      target: null,
      recognition: null,
      isRecognizing: false
    },
    backupPhotosDialog: {
      open: false
    },
    plateRecognitionDialog: {
      open: false,
      media: null
    },
    pendingPlateSelection: {
      dontReturnNewClient: false
    },
    TakePhotoDialog: {
      modal: false,
      component: null,
      index: null
    },
    isOrganizing: false,
    sections: [],
    openSectionPanels: [],
    ordersLoading: [],
    modalAddSection: {
      isOpen: false,
      loading: false
    },
    fixedSectionsLoaded: false
  }),
  mounted() {
    startLocationTracking();
    const userLogged = this.$store.getters['Auth/user'];
    this.$store.dispatch('ClientClassification/getClientClassifications');

    if (userLogged.role.name === 'operational') {
      this.isOperational = true;
    }

    this.isMultipleUpload = true;

    if (this.getOrganizationParameter('DISABLE_MEDIA_MULTIPLE_UPLOADS')) {
      this.isMultipleUpload = false;
    }

    this.setupUploadQueueListeners();

    this.retryTimerInterval = setInterval(() => {
      this.$forceUpdate();
    }, 1000);

    this.init_interval = setInterval(() => {
      const ServiceOrder = this.$store.getters['ServiceOrder/intialDetails'];

      if (ServiceOrder.id) {
        if (this.currentServiceOrderId && this.currentServiceOrderId !== ServiceOrder.id) {
          this.clearServiceOrderState();
          this.uploadQueue.clearAll();
        }

        this.currentServiceOrderId = ServiceOrder.id;

        if (this.isNew && !this.fixedSectionsLoaded) {
          this.fixedSectionsLoaded = true;
          this.addFixedSections();
        }

        this.wheel_torque_status = this.hasActiveWheelTorque(ServiceOrder.wheel_torque);
        this.attachments = ServiceOrder.service_order_attachments ? JSON.parse(JSON.stringify(ServiceOrder.service_order_attachments)) : [];

        this.vehicle_kilometer = ServiceOrder.vehicle_kilometer;
        this.formatKilometragem();

        this.service_deadline.selected_date = new Date(ServiceOrder.forecast_date).toISOString().slice(0, 10);
        this.service_deadline.selected_time = dayjs(ServiceOrder.forecast_date).format('HH:mm');

        this.service_deadline.formated_date = this.formatDate(ServiceOrder.forecast_date);

        this.organizeMediasBySections();

        if (!ServiceOrder.service_order_photos) {
          this.clearInterval();
          return;
        }

        const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');

        ServiceOrder.service_order_photos.forEach((photo) => {
          switch (photo.tag) {
            case 'entry_medias_main':
              this.entry_medias.main = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'entry_medias_front':
              this.entry_medias.front = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'entry_medias_rear':
              this.entry_medias.rear = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'entry_medias_right':
              this.entry_medias.right = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'entry_medias_left':
              this.entry_medias.left = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'entry_medias_panel':
              this.entry_medias.panel = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'entry_medias_secret':
              this.entry_medias.secret = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'entry_medias_step':
              this.entry_medias.step = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'entry_medias_chassi':
              this.entry_medias.chassi = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'entry_medias_motor':
              this.entry_medias.motor = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'leaving_medias_main':
              this.leaving_medias.main = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'leaving_medias_front':
              this.leaving_medias.front = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'leaving_medias_rear':
              this.leaving_medias.rear = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'leaving_medias_right':
              this.leaving_medias.right = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'leaving_medias_left':
              this.leaving_medias.left = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'leaving_medias_panel':
              this.leaving_medias.panel = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'leaving_medias_chassi':
              this.leaving_medias.chassi = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            case 'leaving_medias_motor':
              this.leaving_medias.motor = !photo.type?.includes('video/')
                ? { ...photo, original_photo_url: photo.photo_url, photo_url: thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() }
                : photo;
              break;
            default: {
              //
            }
          }
        });

        this.checkBackupMedias(ServiceOrder);

        this.clearInterval();
      }
    }, 200);
  },
  beforeDestroy() {
    if (this.init_interval) {
      clearInterval(this.init_interval);
      this.init_interval = null;
    }

    if (this.retryTimerInterval) {
      clearInterval(this.retryTimerInterval);
      this.retryTimerInterval = null;
    }

    this.clearServiceOrderState();
  },
  computed: {
    service_order() {
      return this.$store.getters['ServiceOrder/intialDetails'];
    },
    status() {
      return this.$store.getters['ServiceOrder/status'];
    },
    activeSections() {
      return this.sections.filter((section) => section.active !== 0);
    },
    wheel_torque() {
      return this.$store.getters['ServiceOrder/wheel_torque'];
    },
    activeWheelTorque() {
      const wheelTorques = this.wheel_torque;

      if (!wheelTorques || !Array.isArray(wheelTorques)) {
        return null;
      }

      const active = wheelTorques.find((wt) => !!wt.active) || null;
      return active;
    },
    hasWheelTorqueVerified() {
      return this.activeWheelTorque !== null;
    },
    app_mode() {
      return localStorage.getItem('app_mode') || 'advanced';
    },
    parameterMediaBackupHours() {
      return this.$store.getters['Auth/parameters']?.find((parameter) => parameter.name === 'media_backup_hours_stored')?.value;
    },
    parameterMediaCameraType() {
      return this.$store.getters['Auth/parameters']?.find((parameter) => parameter.name === 'media_camera_type')?.value;
    },
    parameterShowUploadQueueStatus() {
      return this.$store.getters['Auth/parameters']?.find((parameter) => parameter.name === 'show_upload_queue_status')?.value || false;
    },
    retryTimesUpdate() {
      return Date.now();
    },
    isMotorcycle() {
      const value = this.getOrganizationParameter('MOTORCYCLE');
      return value === 'true' || value === 'TRUE' || value === true;
    },
    isTractor() {
      const value = this.getOrganizationParameter('TRACTOR');
      return value === 'true' || value === 'TRUE' || value === true;
    },
    isTruck() {
      const value = this.getOrganizationParameter('TRUCK');
      return value === 'true' || value === 'TRUE' || value === true;
    },
    thumbnails() {
      /* eslint-disable global-require */
      const carThumbnails = {
        'photo-01': require('@/assets/car_thumbnails/car-photo-01.jpg'),
        'photo-02': require('@/assets/car_thumbnails/car-photo-02.jpg'),
        'photo-03': require('@/assets/car_thumbnails/car-photo-03.jpg'),
        'photo-04': require('@/assets/car_thumbnails/car-photo-04.jpg'),
        'photo-05': require('@/assets/car_thumbnails/car-photo-05.jpg'),
        'panel': require('@/assets/car_thumbnails/car-panel.png'),
        'chassi': require('@/assets/car_thumbnails/car-chassi.png'),
        'motor': require('@/assets/car_thumbnails/car-motor.png'),
        'secret': require('@/assets/car_thumbnails/secret.png'),
        'step': require('@/assets/car_thumbnails/entry_medias_step.png')
      };

      const motorcycleThumbnails = {
        'photo-01': require('@/assets/motorcycle_thumbnails/motorcycle-photo-02.jpg'),
        'photo-02': require('@/assets/motorcycle_thumbnails/motorcycle-photo-01.jpg'),
        'photo-03': require('@/assets/motorcycle_thumbnails/motorcycle-photo-03.jpg'),
        'photo-04': require('@/assets/motorcycle_thumbnails/motorcycle-photo-05.jpg'),
        'photo-05': require('@/assets/motorcycle_thumbnails/motorcycle-photo-04.jpg'),
        'panel': require('@/assets/motorcycle_thumbnails/motorcycle-panel.png'),
        'chassi': require('@/assets/motorcycle_thumbnails/motorcycle-chassi.png'),
        'motor': require('@/assets/motorcycle_thumbnails/motorcycle-motor.png')
      };

      const tractorThumbnails = {
        'photo-01': require('@/assets/tractor_thumbnails/tractor-photo-01.jpeg'),
        'photo-02': require('@/assets/tractor_thumbnails/tractor-photo-02.jpeg'),
        'photo-03': require('@/assets/tractor_thumbnails/tractor-photo-03.jpeg'),
        'photo-04': require('@/assets/tractor_thumbnails/tractor-photo-04.jpeg'),
        'photo-05': require('@/assets/tractor_thumbnails/tractor-photo-05.jpeg'),
        'panel': require('@/assets/tractor_thumbnails/tractor-panel.jpeg'),
        'chassi': require('@/assets/tractor_thumbnails/tractor-chassi.png'),
        'motor': require('@/assets/tractor_thumbnails/tractor-motor.png')
      };

      const truckThumbnails = {
        'photo-01': require('@/assets/truck_thumbnails/principal.png'),
        'photo-02': require('@/assets/truck_thumbnails/frente.png'),
        'photo-03': require('@/assets/truck_thumbnails/lateral-direita.webp'),
        'photo-04': require('@/assets/truck_thumbnails/tras.png'),
        'photo-05': require('@/assets/truck_thumbnails/lateral-esquerda.webp'),
        'panel': require('@/assets/truck_thumbnails/painel.png'),
        'chassi': require('@/assets/tractor_thumbnails/tractor-chassi.png'),
        'motor': require('@/assets/truck_thumbnails/motor.png')
      };

      /* eslint-enable global-require */
      if (this.isTractor) return tractorThumbnails;
      if (this.isMotorcycle) return motorcycleThumbnails;
      if (this.isTruck) return truckThumbnails;
      return carThumbnails;
    },
    thumbnailPlaceholderContainerClass() {
      return this.isTruck ? 'truck-thumbnail-container' : null;
    }
  },
  methods: {
    setupUploadQueueListeners() {
      this.uploadQueue.on('success', ({ tag }) => {
        this.setLoading(tag, false);
        this.$store.dispatch('ServiceOrder/setMediaLoading', false);
      });

      this.uploadQueue.on('error', ({ tag, error, retryCount, isBlobError }) => {
        console.error(`📸 Erro no upload ${tag} (tentativa ${retryCount}):`, error);

        if (isBlobError) {
          this.$toast.error(`Arquivo ${tag} não está mais disponível. Tente tirar a foto novamente.`, {
            position: 'bottom-right',
            duration: 5000
          });
        }
      });

      this.uploadQueue.on('retry', ({ tag, retryCount, maxRetries }) => {
        let message = `Tentando enviar ${tag} novamente (${retryCount}/${maxRetries})`;
        if (retryCount === 1) {
          message += ' - Usando backup local';
        }

        this.$toast.info(message, {
          position: 'bottom-right',
          duration: 2000
        });
      });

      this.uploadQueue.on('maxRetriesReached', ({ tag, error }) => {
        console.error(`📸 Máximo de tentativas atingido para ${tag}:`, error);
        this.setLoading(tag, false);
        this.$store.dispatch('ServiceOrder/setMediaLoading', false);

        this.$toast.error(`Não foi possível enviar ${tag}. Verifique sua conexão.`, {
          position: 'bottom-right',
          duration: 5000
        });
      });
    },
    openAlternativeTakePhoto(component, index) {
      this.TakePhotoDialog = {
        modal: true,
        component,
        index
      };
    },
    closeAlternativeTakePhoto() {
      this.TakePhotoDialog = {
        modal: false,
        component: null,
        index: null
      };
    },
    async mediaCapturedAlternative(payload) {
      const self = this;
      const { component, index } = this.TakePhotoDialog;

      let file = new File([payload.blob], `${Date.now()}.${payload.type === 'photo' ? 'jpg' : 'mp4'}`, { type: payload.blob.type });

      if (self.status === 'finished' || self.status === 'canceled') {
        return;
      }

      if (payload.type === 'photo') {
        file = await this.convertHeicToJpeg(file);
      }

      self.TakePhotoDialog = {
        modal: false,
        component: null,
        index: null
      };

      if (component === 'service_medias') {
        if (typeof index !== 'undefined') {
          const entryOrder = self[component].findIndex((entry) => entry.order === index);
          self[component][entryOrder].second = file;
          self[component][entryOrder].second.photo_url = URL.createObjectURL(file);
          self.uploadMedia(self[component][entryOrder].second, `${component}_${self[component][entryOrder].order}_second`, {
            component,
            index: self[component][entryOrder].order,
            second: true
          });
        } else {
          const photo = {
            first: file,
            order: self.entry_order,
            second: null
          };
          self.entry_order += 1;
          photo.first.photo_url = URL.createObjectURL(file);
          self[component].unshift(photo);
          self.uploadMedia(photo.first, `${component}_${photo.order}`, { component, index: photo.order, second: false });
        }
      } else if (component === 'breakdowns_medias') {
        if (typeof index !== 'undefined') {
          const entryOrder = self[component].findIndex((entry) => entry.order === index);
          self[component][entryOrder].second = file;
          self[component][entryOrder].second.photo_url = URL.createObjectURL(file);
          self.uploadMedia(self[component][entryOrder].second, `${component}_${self[component][entryOrder].order}_second`, {
            component,
            index: self[component][entryOrder].order,
            second: true
          });
        } else {
          const photo = {
            first: file,
            order: self.breakdowns_order,
            second: null
          };
          self.breakdowns_order += 1;
          photo.first.photo_url = URL.createObjectURL(file);
          self[component].unshift(photo);
          self.uploadMedia(photo.first, `${component}_${photo.order}`, { component, index: photo.order, second: false });
        }
      } else {
        self[component][index] = file;
        self[component][index].photo_url = URL.createObjectURL(file);
        self.uploadMedia(self[component][index], `${component}_${index}`, { component, index, second: false });
      }
    },
    isIphone() {
      if (this.getOS() === 'iOS') {
        return true;
      }
      return !!(this.$route.query.t && this.$route.query.t === 'ios');
    },
    getOS() {
      const uA = navigator.userAgent || navigator.vendor || window.opera;
      if ((/iPad|iPhone|iPod/.test(uA) && !window.MSStream) || (uA.includes('Mac') && 'ontouchend' in document)) return 'iOS';
      return null;
    },
    cancelRecognizeVoice() {
      this.speechToText = {
        target: null,
        recognition: null,
        isRecognizing: false
      };
    },
    recognitionVoice(target) {
      this.speechToText.target = target;
      this.speechToText.isRecognizing = true;
    },
    handleSpeechRecognitionResult(result) {
      // Verifica se o resultado é válido
      if (!result || typeof result !== 'string') {
        console.warn('Resultado de reconhecimento de voz inválido:', result);
        this.cancelRecognizeVoice();
        return;
      }

      // Verifica se mediaToEdit existe
      if (!this.mediaToEdit) {
        console.warn('mediaToEdit não encontrado');
        this.cancelRecognizeVoice();
        return;
      }

      // Inicializa observation se necessário e adiciona o resultado
      if (this.mediaToEdit.observation === null || this.mediaToEdit.observation === undefined) {
        this.mediaToEdit.observation = '';
      } else if (this.mediaToEdit.observation.length > 0) {
        this.mediaToEdit.observation += '\n';
      }
      this.mediaToEdit.observation += result;
      this.cancelRecognizeVoice();
    },
    formatKilometragem() {
      if (this.vehicle_kilometer !== undefined && this.vehicle_kilometer !== null) {
        let value = String(this.vehicle_kilometer).replace(/\D/g, '');
        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        this.vehicle_kilometer = value;
      }
    },
    checkBackupMedias(ServiceOrder) {
      const self = this;

      if (!ServiceOrder || !ServiceOrder.id) {
        return;
      }

      if (self.currentServiceOrderId !== ServiceOrder.id) {
        return;
      }

      dexieDB.checkPendingServiceOrderPhoto(ServiceOrder.id).then((pendingPhotos) => {
        const filteredPhotos = pendingPhotos.filter((photo) => photo.service_order === ServiceOrder.id);

        self.service_order_backup_photos = filteredPhotos.filter(({ attempts }) => !attempts);
        self.service_order_pending_photos = filteredPhotos.filter(({ attempts }) => attempts);

        self.service_order_pending_photos.forEach((photo) => {
          photo.photo_url = URL.createObjectURL(photo.media);
          photo.loading = false;
        });

        const hasLoadingPendingPhotos = self.service_order_pending_photos.some((photo) => photo.loading);
        if (hasLoadingPendingPhotos || self.loading.length > 0) {
          self.$store.dispatch('ServiceOrder/setMediaLoading', true);
        } else {
          self.$store.dispatch('ServiceOrder/setMediaLoading', false);
        }
      });
    },
    clearInterval() {
      if (this.init_interval) {
        clearInterval(this.init_interval);
        this.init_interval = null;
      }
    },
    switchTabChecklist(tab) {
      if (this.activeTabChecklist === tab) return;
      this.activeTabChecklist = tab;
    },
    switchTabPhotosVideos(tab) {
      if (this.activeTabPhotosVideos === tab) return;
      this.activeTabPhotosVideos = tab;
    },
    onFileChangeResize(event, component, index) {
      const self = this;
      if (self.status === 'finished' || self.status === 'canceled') {
        return;
      }
      fetch(event.dataUrl)
        .then((res) => res.blob())
        .then((file) => {
          self[component][index] = new File([file], `${Date.now()}_resized.jpg`, { type: 'image/jpeg' });
          self[component][index].photo_url = URL.createObjectURL(file);
          self.uploadMedia(self[component][index], `${component}_${index}`, { component, index, second: false });
        });
    },
    async onFileChange(event, component, index) {
      const self = this;
      if (self.status === 'finished' || self.status === 'canceled') {
        return;
      }
      if (this.service_order_pending_photos.length > 0) {
        self.$toast.error('SINCRONIZE TODAS AS MÍDAIS PENDENTES PRIMEIRO.', {
          position: 'bottom-right'
        });
        return;
      }

      if (component === 'service_medias') {
        Array.from(event.target.files).forEach(async (fileOriginal, aindex, array) => {
          const file = await this.convertHeicToJpeg(fileOriginal);

          if (typeof index !== 'undefined') {
            const entryOrder = self[component].findIndex((entry) => entry.order === index);
            self[component][entryOrder].second = file;
            self[component][entryOrder].second.photo_url = URL.createObjectURL(file);
            self.uploadMedia(self[component][entryOrder].second, `${component}_${self[component][entryOrder].order}_second`, {
              component,
              index: self[component][entryOrder].order,
              second: true
            });
          } else {
            const photo = {
              first: file,
              order: self.entry_order,
              second: null
            };
            self.entry_order += 1;
            photo.first.photo_url = URL.createObjectURL(file);
            self[component].unshift(photo);
            self.uploadMedia(photo.first, `${component}_${photo.order}`, { component, index: photo.order, second: false });
          }

          if (aindex === array.length - 1) {
            event.target.value = '';
          }
        });
      } else if (component === 'breakdowns_medias') {
        Array.from(event.target.files).forEach(async (fileOriginal, aindex, array) => {
          const file = await this.convertHeicToJpeg(fileOriginal);

          const photo = {
            first: file,
            order: self.breakdowns_order,
            second: null
          };
          self.breakdowns_order += 1;
          photo.first.photo_url = URL.createObjectURL(file);
          self[component].unshift(photo);
          self.uploadMedia(photo.first, `${component}_${photo.order}`, { component, index: photo.order, second: false });

          if (aindex === array.length - 1) {
            event.target.value = '';
          }
        });
      } else {
        Array.from(event.target.files).forEach(async (fileOriginal) => {
          const file = await this.convertHeicToJpeg(fileOriginal);

          self[component][index] = file;
          self[component][index].photo_url = URL.createObjectURL(file);
          self.uploadMedia(self[component][index], `${component}_${index}`, { component, index, second: false });
        });
      }
    },
    confirmDeleteMedia(component, index, second = false) {
      this.confirm_delete = {
        opened: true,
        component,
        second,
        index
      };
    },
    confirmDeleteMediaBackup(id) {
      this.confirm_delete_backup = {
        opened: true,
        id
      };
    },
    async downloadPendingMedia(pendingMedia) {
      const isVideo = pendingMedia.media?.type?.includes('video/');

      if (window.median && window.median.share) {
        try {
          const dataUrl = await this.blobToDataUrl(pendingMedia.media);
          if (isVideo) {
            window.median.share.downloadFile({ url: dataUrl, open: true });
          } else {
            window.median.share.downloadImage({ url: dataUrl });
          }
        } catch (e) {
          console.error('[Photos] Erro ao converter mídia para download:', e);
          this.$toast.error('Erro ao preparar download da mídia.', { position: 'bottom-right' });
        }
      } else {
        const a = document.createElement('a');
        a.href = pendingMedia.photo_url;
        a.download = isVideo ? `video_${Date.now()}.mp4` : `foto_${Date.now()}.jpg`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        this.$toast.success('Download iniciado!', { position: 'bottom-right' });
      }
    },
    blobToDataUrl(blob) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    },
    deleteMediaBackup() {
      dexieDB.removeServiceOrderPhoto(this.confirm_delete_backup.id);
      this.service_order_pending_photos = this.service_order_pending_photos.filter((photo) => photo.id !== this.confirm_delete_backup.id);
      this.confirm_delete_backup = {
        opened: false,
        id: null
      };
    },
    async resyncMediaBackup(backup) {
      const self = this;

      if (!backup || !backup.service_order || backup.service_order !== this.currentServiceOrderId) {
        return;
      }

      self.service_order_pending_photos = self.service_order_pending_photos.map((photo) => {
        if (photo.id === backup.id) {
          return { ...photo, loading: true };
        }
        return photo;
      });

      self.$store.dispatch('ServiceOrder/setMediaLoading', true);

      await dexieDB.incrementAttempts(backup.id);

      const mediaToUpload = await self.getMediaFromBackup(backup.id);
      if (!mediaToUpload) {
        console.error(`📸 Mídia do backup ${backup.id} não está mais disponível`);
        self.service_order_pending_photos = self.service_order_pending_photos.map((photo) => {
          if (photo.id === backup.id) {
            return { ...photo, loading: false };
          }
          return photo;
        });

        if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
          self.$store.dispatch('ServiceOrder/setMediaLoading', false);
        }

        self.$toast.error('Mídia do backup não está mais disponível. Tente tirar a foto novamente.', {
          position: 'bottom-right'
        });
        return;
      }

      // if (self.isMultipleUpload) {
      //  self.uploadMediaMultipartCreate(mediaToUpload, backup.tag, backup.identification, backup);
      //  return;
      // }

      const formData = new FormData();
      formData.append('file', mediaToUpload);
      formData.append('tag', backup.tag);
      formData.append('type', backup.type);
      appendMetadataToFormData(formData);

      try {
        const r = await self.$http.post(`/service_order/${self.service_order.id}/photo/create?type=os&tag=${backup.tag}`, formData, {
          timeout: 1000 * 180,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (this.parameterMediaBackupHours) {
          await dexieDB.removeAttempts(backup.id);
        } else {
          await dexieDB.removeServiceOrderPhoto(backup.id);
        }

        this.resyncPhotoInBackup(backup, r);

        const bkpToRemove = self.service_order_pending_photos.findIndex((photo) => photo.id === backup.id);
        self.service_order_pending_photos.splice(bkpToRemove, 1);

        if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
          self.$store.dispatch('ServiceOrder/setMediaLoading', false);
        }

        this.organizeMediasBySections();
      } catch {
        self.service_order_pending_photos = self.service_order_pending_photos.map((photo) => {
          if (photo.id === backup.id) {
            return { ...photo, loading: false };
          }
          return photo;
        });

        if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
          self.$store.dispatch('ServiceOrder/setMediaLoading', false);
        }
      }
    },
    deleteMedia() {
      const self = this;
      const { component, index, second } = self.confirm_delete;

      self.confirm_delete.opened = false;

      let mediaId = null;
      if (second) {
        const entryOrder = self[component].findIndex((entry) => entry.order === index);
        if (entryOrder !== -1 && self[component][entryOrder] && self[component][entryOrder].second) {
          mediaId = self[component][entryOrder].second.id;
          self[component][entryOrder].second = false;
        }
      } else if (component === 'service_medias') {
        const entryOrder = self[component].findIndex((entry) => entry.order === index);
        if (entryOrder !== -1 && self[component][entryOrder] && self[component][entryOrder].first) {
          mediaId = self[component][entryOrder].first.id;
          if (self[component][entryOrder].second) {
            self[component][entryOrder].first = self[component][entryOrder].second;
            self[component][entryOrder].second = false;
          } else {
            self[component].splice(entryOrder, 1);
          }
        }
      } else if (component === 'breakdowns_medias') {
        const entryOrder = self[component].findIndex((entry) => entry.order === index);
        if (entryOrder !== -1 && self[component][entryOrder] && self[component][entryOrder].first) {
          mediaId = self[component][entryOrder].first.id;
          self[component].splice(entryOrder, 1);
        }
      } else if (self[component] && self[component][index]) {
        mediaId = self[component][index].id;
        self[component][index] = null;
      }

      if (mediaId && mediaId !== null && mediaId !== undefined) {
        self.$store.dispatch('ServiceOrder/deleteMedia', mediaId);
      }
    },
    async uploadMedia(media, tag, identification) {
      const self = this;

      if (!self.service_order || !self.service_order.id || self.service_order.id !== self.currentServiceOrderId) {
        return;
      }

      if (self.uploadQueue.isUploadActive(tag)) {
        return;
      }

      if (!media || (!(media instanceof File) && !(media instanceof Blob))) {
        console.error(`📸 Arquivo inválido para upload ${tag}:`, media);
        self.$toast.error('Arquivo inválido. Tente tirar a foto novamente.', {
          position: 'bottom-right'
        });
        return;
      }

      try {
        const testUrl = URL.createObjectURL(media);
        URL.revokeObjectURL(testUrl);
      } catch (blobError) {
        console.error(`📸 Blob corrompido para upload ${tag}:`, blobError);
        self.$toast.error('Arquivo corrompido. Tente tirar a foto novamente.', {
          position: 'bottom-right'
        });
        return;
      }

      const uploadFunction = async () => {
        if (self.isMultipleUpload) {
          return self.uploadMediaMultipartCreate(media, tag, identification);
        }
        return self.uploadMediaDirect(media, tag, identification);
      };

      self.uploadQueue.setUploadActive(tag, {
        media,
        tag,
        identification,
        uploadFunction
      });

      self.setLoading(tag, true);

      if (tag === 'entry_medias_rear') {
        self.plateRecognitionDialog.media = media;
        self.plateRecognitionDialog.open = true;
      }

      const bkpPhotoId = await self.localBackupMedia(media, tag, false);

      try {
        await uploadFunction();

        self.uploadQueue.removeActiveUpload(tag);
        self.setLoading(tag, false);

        if (this.parameterMediaBackupHours) {
          await dexieDB.removeAttempts(bkpPhotoId);
        }
        if (!this.parameterMediaBackupHours) {
          await dexieDB.removeServiceOrderPhoto(bkpPhotoId);
        }
      } catch (error) {
        console.error(`📸 Erro no upload para ${tag}:`, error);

        const retryAdded = self.uploadQueue.addToRetryQueue(
          tag,
          {
            media,
            tag,
            identification,
            backupId: bkpPhotoId,
            uploadFunction: async () => {
              const backupMedia = await self.getMediaFromBackup(bkpPhotoId);
              if (!backupMedia) {
                throw new Error('Backup da mídia não encontrado para retry');
              }

              if (self.isMultipleUpload) {
                return self.uploadMediaMultipartCreate(backupMedia, tag, identification);
              }
              return self.uploadMediaDirect(backupMedia, tag, identification);
            }
          },
          error
        );

        if (!retryAdded) {
          self.revertUploadChanges(tag, identification);
          self.setLoading(tag, false);
          self.$store.dispatch('ServiceOrder/setVehicleLoading', false);
        }
      } finally {
        const orderIndex = this.ordersLoading.findIndex((o) => o === identification.index);
        if (orderIndex !== -1) this.ordersLoading.splice(orderIndex, 1);
      }
    },
    async uploadMediaDirect(media, tag, identification) {
      const self = this;

      const formData = new FormData();
      formData.append('file', media);
      formData.append('tag', tag);
      formData.append('type', media.type);
      appendMetadataToFormData(formData);

      const r = await self.$http.post(`/service_order/${self.service_order.id}/photo/create?type=os&tag=${tag}`, formData, {
        timeout: 1000 * 180,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      self.setMediaId(identification, r.data.created_id, r.data.created_at);
      self.$store.dispatch('ServiceOrder/addMedia', { id: r.data.created_id, created_at: r.data.created_at, photo_url: r.data.photo_url, tag });

      if (tag === 'entry_medias_rear') {
        self.$refs.plateRecognitionDialog.media_created_id = r.data.created_id;
        self.$refs.plateRecognitionDialog.step = 'recognizing';
        self.plateRecognitionDialog.media = { ...self.plateRecognitionDialog.media, photo_url_cloud: r.data.photo_url };
      }

      return r;
    },
    revertUploadChanges(tag, identification) {
      const self = this;

      if (tag.includes('service_medias')) {
        if (identification.second) {
          const entryOrder = self[identification.component].findIndex((entry) => entry.order === identification.index);
          if (entryOrder !== -1) {
            self[identification.component][entryOrder].second = false;
          }
        } else if (identification.component === 'service_medias') {
          const entryOrder = self[identification.component].findIndex((entry) => entry.order === identification.index);
          if (entryOrder !== -1) {
            if (self[identification.component][entryOrder].second) {
              self[identification.component][entryOrder].first = self[identification.component][entryOrder].second;
              self[identification.component][entryOrder].second = false;
            } else {
              self[identification.component].splice(entryOrder, 1);
            }
          }
        } else {
          self[identification.component][identification.index] = null;
        }
      } else if (tag.includes('breakdowns_medias')) {
        if (identification.component === 'breakdowns_medias') {
          const entryOrder = self[identification.component].findIndex((entry) => entry.order === identification.index);
          if (entryOrder !== -1) {
            self[identification.component].splice(entryOrder, 1);
          }
        } else {
          self[identification.component][identification.index] = null;
        }
      } else if (self[identification.component] && self[identification.component][identification.index]) {
        self[identification.component][identification.index] = null;
      }
    },
    async getMediaFromBackup(backupId) {
      try {
        const backup = await dexieDB.table('serviceOrderPhoto').get(backupId);
        if (!backup || !backup.media) {
          return null;
        }

        if (backup.media instanceof File || backup.media instanceof Blob) {
          try {
            const testUrl = URL.createObjectURL(backup.media);
            URL.revokeObjectURL(testUrl);
            return backup.media;
          } catch (blobError) {
            console.error(`📸 Blob corrompido no backup ${backupId}:`, blobError);
            return null;
          }
        }

        return null;
      } catch (error) {
        console.error(`📸 Erro ao recuperar backup ${backupId}:`, error);
        return null;
      }
    },
    async localBackupMedia(media, tag, reloadBackupMedias = true) {
      try {
        if (!this.service_order || !this.service_order.id || this.service_order.id !== this.currentServiceOrderId) {
          return null;
        }

        const existingMedia = await dexieDB
          .table('serviceOrderPhoto')
          .where('service_order')
          .equals(this.service_order.id)
          .and((item) => item.tag === tag)
          .first();

        if (existingMedia) {
          await dexieDB.table('serviceOrderPhoto').update(existingMedia.id, {
            media,
            type: media.type,
            created_at: new Date().toISOString(),
            attempts: 1
          });

          if (reloadBackupMedias) {
            this.checkBackupMedias(this.service_order);
          }
          return existingMedia.id;
        }

        const newServiceOrderPhoto = {
          service_order: this.service_order.id,
          tag,
          media,
          type: media.type,
          observation: '',
          created_at: new Date().toISOString(),
          visible: !tag.includes('breakdowns_medias'),
          attempts: 1
        };

        const createdId = await dexieDB.addServiceOrderPhoto(newServiceOrderPhoto);
        if (reloadBackupMedias) {
          this.checkBackupMedias(this.service_order);
        }
        return createdId;
      } catch (err) {
        console.error('Erro ao adicionar/atualizar o registro:', err);
        throw err;
      }
    },
    async uploadMediaMultipartCreate(file, tag, identification, resync = false) {
      const self = this;

      self.setLoading(tag, true);

      let useMultipart = true;

      if (self.getOrganizationParameter('DISABLE_MEDIA_MULTIPLE_UPLOADS')) {
        useMultipart = false;
      }

      try {
        let fileName = file.name;
        if (!fileName || fileName === 'photo.png' || fileName === 'assinatura.png') {
          const timestamp = Date.now();
          const extension = file.type.includes('video/') ? 'mp4' : 'jpg';
          fileName = `${tag}_${timestamp}.${extension}`;
        }

        if (!resync) {
          self.localBackupMedia(file, tag, false);
        }

        if (useMultipart) {
          const response = await self.$http.post(`/service_order/${self.service_order.id}/turbo/create-multipart-upload?tag=${tag}`, {
            key: fileName,
            contentType: file.type,
            usePresignedMultipart: true,
            fileSize: file.size
          });

          try {
            await self.uploadMediaMultipartWithPresignedUrls(file, response.data, tag, identification, resync);
          } catch (multipartError) {
            await self.uploadViaBackend(file, tag, identification, resync);
          }
        } else {
          const response = await self.$http.post(`/service_order/${self.service_order.id}/turbo/create-multipart-upload?tag=${tag}`, {
            key: fileName,
            contentType: file.type
          });

          try {
            await self.uploadDirectToS3(file, response.data.uploadUrl, response.data.key, response.data.contentType, tag, identification, resync);
          } catch (corsError) {
            await self.uploadViaBackend(file, tag, identification, resync);
          }
        }
      } catch (error) {
        self.setLoading(tag, false);

        if (resync) {
          self.service_order_pending_photos = self.service_order_pending_photos.map((photo) => {
            if (photo.id === resync.id) {
              return { ...photo, loading: false };
            }
            return photo;
          });

          if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
            self.$store.dispatch('ServiceOrder/setMediaLoading', false);
          }
        }

        throw new Error(`Falha ao criar upload: ${error.message}`);
      }
    },
    async uploadDirectToS3(file, uploadUrl, key, contentType, tag, identification, resync) {
      const self = this;
      const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');

      try {
        const uploadResponse = await fetch(uploadUrl, {
          method: 'PUT',
          body: file,
          headers: {
            'Content-Type': contentType || file.type
          }
        });

        if (!uploadResponse.ok) {
          throw new Error(`Erro no upload para S3: ${uploadResponse.status}`);
        }

        const confirmResponse = await self.$http.post(`/service_order/${self.service_order.id}/turbo/complete-multipart-upload`, {
          key,
          type: file.type,
          tag,
          ...getMetadataForJson()
        });

        const cloudPhotoUrl = 'https://cdn-02.checkmotors.net/v1/' + key;

        if (tag === 'entry_medias_rear') {
          self.$store.dispatch('ServiceOrder/setLoading', false);
          const thumborPhoto = thumbor
            .setImagePath(cloudPhotoUrl)
            .resize(720, 0)
            .buildUrl();
          self.setClientByVehiclePlate(thumborPhoto);
        } else {
          self.$store.dispatch('ServiceOrder/setLoading', false);
        }

        if (resync) {
          self.$store.dispatch('ServiceOrder/addMedia', {
            id: confirmResponse.data.created_id,
            created_at: confirmResponse.data.created_at,
            photo_url: cloudPhotoUrl,
            tag: resync.tag
          });

          if (self.parameterMediaBackupHours) {
            await dexieDB.removeAttempts(resync.id);
          } else {
            await dexieDB.removeServiceOrderPhoto(resync.id);
          }

          const bkpToRemove = self.service_order_pending_photos.findIndex((photo) => photo.id === resync.id);
          if (bkpToRemove !== -1) {
            self.service_order_pending_photos.splice(bkpToRemove, 1);
          }

          if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
            self.$store.dispatch('ServiceOrder/setMediaLoading', false);
          }

          self.resyncPhotoInBackup(resync, confirmResponse);
        } else {
          self.setMediaId(identification, confirmResponse.data.created_id, confirmResponse.data.created_at);
          self.$store.dispatch('ServiceOrder/addMedia', {
            id: confirmResponse.data.created_id,
            created_at: confirmResponse.data.created_at,
            photo_url: cloudPhotoUrl,
            tag
          });

          if (self.parameterMediaBackupHours) {
            await dexieDB.removeAttemptsByTag(self.service_order.id, tag);
          } else {
            await dexieDB.removeServiceOrderPhotoByTag(self.service_order.id, tag);
          }
        }

        self.setLoading(tag, false);
      } catch (error) {
        self.setLoading(tag, false);

        if (resync) {
          self.service_order_pending_photos = self.service_order_pending_photos.map((photo) => {
            if (photo.id === resync.id) {
              return { ...photo, loading: false };
            }
            return photo;
          });

          if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
            self.$store.dispatch('ServiceOrder/setMediaLoading', false);
          }
        }

        throw new Error(`Falha no upload direto: ${error.message}`);
      }
    },
    async uploadMediaMultipart(file, tag, identification, uploadId, key, resync) {
      const partSize = 5 * 1024 * 1024;
      const parts = [];

      try {
        const uploadPromises = [];

        for (let start = 0; start < file.size; start += partSize) {
          const end = Math.min(start + partSize, file.size);
          const part = file.slice(start, end);

          const partNumber = Math.floor(start / partSize) + 1;
          const formData = new FormData();
          formData.append('key', key);
          formData.append('partNumber', `${partNumber}`);
          formData.append('uploadId', uploadId);
          formData.append('filePart', part);

          uploadPromises.push(
            this.$http
              .post(`/service_order/turbo/upload-part`, formData, {
                timeout: 1000 * 120,
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then((response) => ({
                ETag: response.data.ETag,
                PartNumber: partNumber
              }))
          );
        }

        const uploadedParts = await Promise.all(uploadPromises);

        parts.push(...uploadedParts);
        parts.sort((a, b) => a.PartNumber - b.PartNumber);

        await this.uploadMediaMultipartFinish(file, parts, tag, identification, key, uploadId, resync);
      } catch (error) {
        this.setLoading(tag, false);

        if (resync) {
          this.service_order_pending_photos = this.service_order_pending_photos.map((photo) => {
            if (photo.id === resync.id) {
              return { ...photo, loading: false };
            }
            return photo;
          });

          if (this.service_order_pending_photos.length === 0 && this.loading.length === 0) {
            this.$store.dispatch('ServiceOrder/setMediaLoading', false);
          }
        }

        throw new Error(`Falha ao fazer upload das partes: ${error.message}`);
      }
    },
    async uploadMediaMultipartFinish(file, parts, tag, identification, key, uploadId, resync) {
      const self = this;
      const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');
      try {
        const response = await self.$http.post(`/service_order/${self.service_order.id}/turbo/complete-multipart-upload`, {
          key,
          uploadId,
          parts,
          type: file.type,
          tag,
          ...getMetadataForJson()
        });

        const cloudPhotoUrl = 'https://cdn-02.checkmotors.net/v1/' + key;

        if (tag === 'entry_medias_rear') {
          self.$store.dispatch('ServiceOrder/setLoading', false);
          const thumborPhoto = thumbor
            .setImagePath(cloudPhotoUrl)
            .resize(720, 0)
            .buildUrl();
          self.setClientByVehiclePlate(thumborPhoto);
        } else {
          self.$store.dispatch('ServiceOrder/setLoading', false);
        }

        if (resync) {
          self.$store.dispatch('ServiceOrder/addMedia', { id: response.data.created_id, created_at: response.data.created_at, photo_url: cloudPhotoUrl, tag: resync.tag });

          if (self.parameterMediaBackupHours) {
            await dexieDB.removeAttempts(resync.id);
          } else {
            await dexieDB.removeServiceOrderPhoto(resync.id);
          }

          const bkpToRemove = self.service_order_pending_photos.findIndex((photo) => photo.id === resync.id);
          if (bkpToRemove !== -1) {
            self.service_order_pending_photos.splice(bkpToRemove, 1);
          }

          if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
            self.$store.dispatch('ServiceOrder/setMediaLoading', false);
          }

          self.resyncPhotoInBackup(resync, response);
        } else {
          self.setMediaId(identification, response.data.created_id, response.data.created_at);
          self.$store.dispatch('ServiceOrder/addMedia', {
            id: response.data.created_id,
            created_at: response.data.created_at,
            photo_url: cloudPhotoUrl,
            tag
          });

          if (self.parameterMediaBackupHours) {
            await dexieDB.removeAttemptsByTag(self.service_order.id, tag);
          } else {
            await dexieDB.removeServiceOrderPhotoByTag(self.service_order.id, tag);
          }
        }

        self.setLoading(tag, false);
      } catch (error) {
        self.setLoading(tag, false);

        if (resync) {
          self.service_order_pending_photos = self.service_order_pending_photos.map((photo) => {
            if (photo.id === resync.id) {
              return { ...photo, loading: false };
            }
            return photo;
          });

          if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
            self.$store.dispatch('ServiceOrder/setMediaLoading', false);
          }
        }

        throw new Error(`Falha ao completar upload multipart: ${error.message}`);
      }
    },
    setLoading(tag, status) {
      if (status) {
        if (!this.loading.includes(tag)) {
          this.loading.push(tag);
        }
        this.$store.dispatch('ServiceOrder/setMediaLoading', true);
      } else {
        const index = this.loading.indexOf(tag);
        if (index > -1) {
          this.loading.splice(index, 1);
        }

        const hasPendingBackups = this.service_order_pending_photos.filter((photo) => photo.loading).length > 0;
        const hasQueueUploads = this.uploadQueue.hasPendingUploads();

        if (this.loading.length === 0 && !hasPendingBackups && !hasQueueUploads) {
          this.$store.dispatch('ServiceOrder/setMediaLoading', false);
        }
      }
    },
    getStatus(tag) {
      const isInLoadingArray = !!this.loading.find((e) => e.includes(tag));
      const isInUploadQueue = this.uploadQueue.isUploadActive(tag) || this.uploadQueue.getUploadStatus(tag);

      return isInLoadingArray || !!isInUploadQueue;
    },
    setMediaId(identification, id, createdAt) {
      const { component, index, second } = identification;

      if (this[component] && this[component][index]) {
        this[component][index].id = id;
        this[component][index].created_at = createdAt;
      } else {
        const section = this.sections.find((s) => s.tag === component);
        if (section) {
          const item = section.items.find((item) => item.order === index);
          if (item) {
            const mediaKey = second ? 'second' : 'first';
            if (item[mediaKey]) {
              item[mediaKey].id = id;
              item[mediaKey].created_at = createdAt;
              item[mediaKey].visible = !component.includes('breakdowns_medias');
            }
          }
        }
      }
    },
    setClientByVehiclePlate(media, dontReturnNewClient = false) {
      const self = this;

      self.$store.dispatch('ServiceOrder/setVehicleLoading', true);

      self.$http
        .post(
          '/vehicle/plate',
          { photo_url: media },
          {
            timeout: 1000 * 120
          }
        )
        .then((r) => {
          if (r.data.plates && r.data.plates.length > 1) {
            self.$store.dispatch('ServiceOrder/setVehicleLoading', false);
            self.$store.dispatch('ServiceOrder/setLoading', false);
            self.pendingPlateSelection = { dontReturnNewClient };
            self.plateRecognitionDialog.open = true;
            self.$nextTick(() => {
              self.$refs.plateRecognitionDialog.showVehiclePlates(r.data.plates);
            });
            return;
          }

          if (dontReturnNewClient) {
            self.newVehicleByPlateAlternativeMethod(r.data.plate, dontReturnNewClient.id, true);
            self.closePlateRecognition();
          } else if (r.data && r.data.vehicle) {
            self.$store.dispatch('ServiceOrder/setVehicleLoading', false);
            self.$store.dispatch('ServiceOrder/setLoading', false);
            setTimeout(() => {
              self.$store.dispatch('ServiceOrder/setClientByVehiclePlate', r.data);
              self.closePlateRecognition();
            }, 1000);
          } else {
            self.$store.dispatch('ServiceOrder/setVehicleLoading', false);
            self.$store.dispatch('ServiceOrder/setLoading', false);
            self.newClientCallback(r.data);
          }
        })
        .catch(() => {
          self.$store.dispatch('ServiceOrder/setVehicleLoading', false);
          self.$store.dispatch('ServiceOrder/setLoading', false);
          self.closePlateRecognition();
        });
    },
    async handlePlateSelected(plate) {
      const self = this;
      const { dontReturnNewClient } = self.pendingPlateSelection;

      self.closePlateRecognition();
      self.$store.dispatch('ServiceOrder/setVehicleLoading', true);

      try {
        const { data } = await self.$http.get(`/recognize_plate/check_vehicle_client/${plate}`);

        if (dontReturnNewClient) {
          self.newVehicleByPlateAlternativeMethod(plate, dontReturnNewClient.id, true);
        } else if (data.vehicle) {
          self.$store.dispatch('ServiceOrder/setVehicleLoading', false);
          self.$store.dispatch('ServiceOrder/setLoading', false);
          setTimeout(() => {
            self.$store.dispatch('ServiceOrder/setClientByVehiclePlate', data);
          }, 1000);
        } else {
          self.$store.dispatch('ServiceOrder/setVehicleLoading', false);
          self.$store.dispatch('ServiceOrder/setLoading', false);
          self.newClientCallback(data);
        }
      } catch {
        self.$store.dispatch('ServiceOrder/setVehicleLoading', false);
        self.$store.dispatch('ServiceOrder/setLoading', false);
      }

      self.pendingPlateSelection = { dontReturnNewClient: false };
    },
    newClientCallback(vehicle) {
      this.new_client.vehicle_plate = vehicle.plate;
      this.new_client.dialog = true;
      this.closePlateRecognition();
    },
    closeNewClientDialog(client) {
      if (client) {
        this.newVehicleByPlateAlternativeMethod(this.new_client.vehicle_plate, client.id);
      }
      this.new_client = {
        dialog: false,
        vehicle_plate: null
      };
    },
    async newVehicleByPlate(vehiclePlate, clientId) {
      const self = this;
      const requestOptions = {
        method: 'POST',
        redirect: 'follow'
      };

      self.$store.dispatch('ServiceOrder/setLoading', false);

      const plateImage = await self.downloadPlate(vehiclePlate);
      if (!plateImage) {
        self.$toast.info('Não encontramos os dados do veículo, cadastre manualmente.');
        self.$store.dispatch('ServiceOrder/setLoading', false);
      } else {
        fetch(`https://pf.checkmotors.workers.dev/?https://www.tabelafipebrasil.com/placa/${vehiclePlate}`, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            const formData = new FormData();
            formData.append('file', plateImage);
            formData.append('client_id', clientId);
            formData.append('vehicle_plate', vehiclePlate);
            formData.append('result', result);

            self.$http
              .post(`/vehicle/create/plate`, formData, {
                timeout: 1000 * 120,
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              })
              .then((r) => {
                self.$store.dispatch('ServiceOrder/setClientByVehiclePlate', r.data);
                self.$store.dispatch('ServiceOrder/setLoading', false);
              })
              .catch(() => {
                self.$store.dispatch('ServiceOrder/setLoading', false);
              });
          });
      }
    },
    async newVehicleByPlateAlternativeMethod(vehiclePlate, clientId, reprocess = false) {
      const self = this;
      let plateImage = null;

      self.$store.dispatch('ServiceOrder/setVehicleLoading', true);
      self.$store.dispatch('ServiceOrder/setLoading', false);

      if (this.getOrganizationParameter('ALTERNATIVE_PLATE')) {
        plateImage = await self.downloadPlateAlternative(vehiclePlate);
      } else {
        plateImage = await self.downloadPlate(vehiclePlate);
        if (!plateImage) {
          plateImage = await self.downloadPlateAlternative(vehiclePlate);
        }
      }

      const formData = new FormData();
      formData.append('file', plateImage);
      formData.append('client_id', clientId);
      formData.append('vehicle_plate', vehiclePlate.toUpperCase());
      formData.append('reprocess', reprocess);

      self.$http
        .post(`/vehicle/create/alternative`, formData, {
          timeout: 1000 * 180,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((r) => {
          self.$store.dispatch('ServiceOrder/setVehicleLoading', false);
          self.$store.dispatch('ServiceOrder/setClientByVehiclePlate', r.data);
          self.$store.dispatch('ServiceOrder/setLoading', false);
          self.type_plate_modal = {
            loading: false,
            opened: false,
            plate: null
          };
        })
        .catch(() => {
          self.$store.dispatch('ServiceOrder/setVehicleLoading', false);

          if (reprocess) {
            self.$toast.error('NÃO ENCONTRAMOS DADOS DESTE VEICULO, FAÇA O CADASTRO MANUAL.', {
              position: 'bottom-right'
            });
          } else {
            self.newVehicleByPlateAlternativeMethod(vehiclePlate, clientId, true);
          }

          self.$store.dispatch('ServiceOrder/setLoading', false);
          self.type_plate_modal = {
            loading: false,
            opened: false,
            plate: null
          };
        });
    },
    getRearCloudUrl() {
      const { rear } = this.entry_medias;
      if (!rear) return null;

      const url = rear.original_photo_url || rear.photo_url;
      if (url && !url.includes('blob:')) {
        const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');
        return thumbor.setImagePath(url).resize(720, 0).buildUrl();
      }

      const storePhoto = this.service_order?.service_order_photos?.find(
        (p) => p.tag === 'entry_medias_rear'
      );
      if (storePhoto?.photo_url) {
        const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');
        return thumbor.setImagePath(storePhoto.photo_url).resize(720, 0).buildUrl();
      }

      return null;
    },
    updateVehiclePlateByPhoto(client) {
      const cloudUrl = this.getRearCloudUrl();
      if (cloudUrl) {
        this.setClientByVehiclePlate(cloudUrl, client);
      }
    },
    reprocessPlate() {
      const cloudUrl = this.getRearCloudUrl();
      if (cloudUrl) {
        this.$store.dispatch('ServiceOrder/setLoading', true);
        this.setClientByVehiclePlate(cloudUrl);
      }
    },
    uppercaseVehiclePlate() {
      this.type_plate_modal.plate = this.type_plate_modal.plate.toUpperCase();
    },
    typePlate() {
      this.type_plate_modal.loading = true;

      if (!this.service_order.client || !this.service_order.client.id) {
        this.$toast.error('ESPECIFIQUE UM CLIENTE PRIMEIRO', {
          position: 'bottom-right'
        });
        this.type_plate_modal.loading = false;
        return;
      }

      if (this.type_plate_modal.plate && this.type_plate_modal.plate.length === 7) {
        this.$store.dispatch('ServiceOrder/setLoading', true);
        this.newVehicleByPlateAlternativeMethod(this.type_plate_modal.plate, this.service_order.client.id, true);
      } else {
        this.$toast.error('ESPECIFIQUE UMA PLACA VÁLIDA', {
          position: 'bottom-right'
        });
        this.type_plate_modal.loading = false;
      }
    },
    async downloadPlate(vehiclePlate) {
      let media = false;
      await fetch(`https://pf.checkmotors.workers.dev/?https://placafipe.com/images/placas/reais/QBQ/tabelafipebrasil.com-placa-${vehiclePlate}.png`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
          }
          return res.blob();
        })
        .then((file) => {
          if (file.size > 3500) {
            media = new File([file], `${Date.now()}_plate.jpg`, { type: 'image/jpeg' });
            media.photo_url = URL.createObjectURL(file);
          }
        })
        .catch(() => {
          media = false;
        });
      if (!media) {
        await fetch(`https://pf.checkmotors.workers.dev/?https://www.tabelafipebrasil.com/site/images/placas/reais/RRU/tabelafipebrasil.com-placa-${vehiclePlate}.png`)
          .then((res) => {
            if (!res.ok) {
              throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.blob();
          })
          .then((file) => {
            if (file.size > 3500) {
              media = new File([file], `${Date.now()}_plate.jpg`, { type: 'image/jpeg' });
              media.photo_url = URL.createObjectURL(file);
            }
          })
          .catch(() => {
            media = false;
          });
      }
      return media;
    },
    async downloadPlateAlternative(vehiclePlate) {
      let media = false;
      await this.$http.get(`/vehicle/${vehiclePlate}/plate`, { responseType: 'blob' }).then((file) => {
        media = new File([file.data], `${Date.now()}_plate.jpg`, { type: 'image/jpeg' });
        media.photo_url = URL.createObjectURL(file.data);
      });
      return media;
    },
    handleEditMediaObservation(media, showHideMediaBtn = false) {
      this.showHideMediaBtn = showHideMediaBtn;
      this.mediaToEdit = JSON.parse(JSON.stringify(media));
      this.isModalEditObservationsActive = true;
    },
    editMediaObservation() {
      this.$store.dispatch('ServiceOrder/setLoading', true);

      const serviceOrderId = this.service_order.id;
      const mediaId = this.mediaToEdit.id;

      const data = {
        ...this.mediaToEdit,
        service_order_id: serviceOrderId
      };

      ServiceOrderPhotoService.update(serviceOrderId, mediaId, data)
        .then((r) => {
          this.$toast.success('Observação atualizada com sucesso');
          this.closeEditObservationsModal();

          this.$store.dispatch('ServiceOrder/setLoading', false);

          if (r.data.tag.includes('entry_medias')) {
            const entryMedia = this.entry_medias[r.data.tag.split('_')[2]];

            this.entry_medias[r.data.tag.split('_')[2]] = {
              ...entryMedia,
              observation: r.data.observation
            };
          } else if (r.data.tag.includes('breakdowns_medias')) {
            const breakdownsMediaIndex = this.breakdowns_medias.findIndex((media) => media.first.id === mediaId);

            if (breakdownsMediaIndex !== -1) {
              this.breakdowns_medias[breakdownsMediaIndex].first = r.data;
            }
          } else {
            const serviceMediaIndex = this.service_medias.findIndex(
              (media) => media.first.id === mediaId || (media.second && media.second !== null && media.second.id === mediaId)
            );

            if (serviceMediaIndex !== -1) {
              const serviceMedia = this.service_medias[serviceMediaIndex];

              if (serviceMedia.first.id === mediaId) {
                this.service_medias[serviceMediaIndex].first = r.data;
              } else {
                this.service_medias[serviceMediaIndex].second = r.data;
              }
            }
          }
        })
        .finally(() => {
          this.$store.dispatch('ServiceOrder/setLoading', false);

          this.mediaToEdit = {
            observation: null
          };
        });
    },
    closeEditObservationsModal() {
      if (this.mediaToEdit.isRecognizing && this.isIphone()) {
        this.stopRecognitionIphone();
      }
      this.isModalEditObservationsActive = false;
    },
    saveVehicleKilometer() {
      const km = this.vehicle_kilometer ? String(this.vehicle_kilometer).replace(/\D/g, '') : '';
      this.$store.dispatch('ServiceOrder/saveVehicleKilometer', km);
    },
    formatDate(date) {
      if (!date) return null;
      return dayjs(date).format('DD/MM/YYYY - HH:mm');
    },
    parseDate(date) {
      if (!date) return null;
      return dayjs(date).format('DD/MM/YYYY - HH:mm');
    },
    updateForecastDate(date, time) {
      const dateToUpdate = new Date(`${date} ${time}`);

      this.$refs.dialogdeadline.save(date);
      this.$store.dispatch('ServiceOrder/saveForecastDate', dateToUpdate).then(() => {
        this.service_deadline.date_modal = false;
        this.service_deadline.date_step = 0;

        this.service_deadline.formated_date = this.formatDate(dateToUpdate);
      });
    },
    handleRenameAttachment(attachment) {
      this.attachmentToRename = attachment;
      this.isModalRenameAttachmentActive = true;
    },
    renameAttachment() {
      this.isModalRenameAttachmentActive = false;
      this.$store.dispatch('ServiceOrder/setLoading', true);

      ServiceOrderAttachmentService.update(this.attachmentToRename.id, { description: this.attachmentToRename.description })
        .then(() => {
          this.$toast.success('Anexo renomeado com sucesso');

          const attachmentIndex = this.attachments.findIndex((attachment) => attachment.id === this.attachmentToRename.id);

          if (attachmentIndex !== -1) {
            this.attachments[attachmentIndex].description = this.attachmentToRename.description;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.dispatch('ServiceOrder/setLoading', false);

          this.attachmentToRename = {
            id: null,
            description: null
          };
        });
    },
    handleUploadAttachment(attachment) {
      this.$store.dispatch('ServiceOrder/setLoading', true);

      const ServiceOrder = this.$store.getters['ServiceOrder/intialDetails'];

      const formData = new FormData();
      formData.append('file', attachment);

      ServiceOrderAttachmentService.create(ServiceOrder.id, formData)
        .then((response) => {
          this.$toast.success('Anexo adicionado com sucesso');

          this.attachments.push(response.data);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.dispatch('ServiceOrder/setLoading', false);
        });
    },
    handleToggleVisibility(attachment) {
      this.$store.dispatch('ServiceOrder/setLoading', true);

      api
        .put(`/service_order_attachment/${attachment.id}`, {
          client_visible: attachment.visible
        })
        .then(() => {
          this.$toast.success('Visibilidade alterada com sucesso');
          this.$store.dispatch('ServiceOrder/getServiceOrder', this.service_order.id);
        })
        .catch(() => {
          this.$toast.error('Erro ao alterar visibilidade');
        })
        .finally(() => {
          this.$store.dispatch('ServiceOrder/setLoading', false);
        });
    },
    handleDeleteAttachment(attachment) {
      this.attachmentToRename = attachment;
      this.isRemoveAttachmentModalActive = true;
    },
    removeAttachment() {
      this.isRemoveAttachmentModalActive = false;
      this.$store.dispatch('ServiceOrder/setLoading', true);

      const ServiceOrder = this.$store.getters['ServiceOrder/intialDetails'];

      ServiceOrderAttachmentService.inactivate(ServiceOrder.id, this.attachmentToRename.id)
        .then(() => {
          this.$toast.success('Anexo removido com sucesso');

          const attachmentIndex = this.attachments.findIndex((attachment) => attachment.id === this.attachmentToRename.id);

          if (attachmentIndex !== -1) {
            this.attachments.splice(attachmentIndex, 1);
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$store.dispatch('ServiceOrder/setLoading', false);

          this.attachmentToRename = {
            id: null,
            description: null
          };
        });
    },
    handleObservation(user) {
      const loggedUser = this.$store.getters['Auth/user'];
      if (loggedUser.id === user.id) {
        return 'você';
      }

      return user.name;
    },
    getOrganizationParameter(code) {
      const user = this.$store.getters['Auth/user'];
      const search = user.organization.organization_parameters.find((parameter) => parameter.code === code);
      return search ? search.value : false;
    },
    getThumbnail(imageName) {
      return this.thumbnails[imageName];
    },
    getThumborImage(photo) {
      if (photo.photo_url.includes('blob')) {
        return photo.photo_url;
      }
      const thumbor = new Thumbor('y37r666f2300d9gkf', 'https://thumbnail.checkmotors.net');
      return photo.type !== 'video/mp4' ? thumbor.setImagePath(photo.photo_url).resize(340, 0).buildUrl() : photo.photo_url;
    },
    closeModalBackupPhotos() {
      this.backupPhotosDialog.open = false;
    },
    closePlateRecognition() {
      this.plateRecognitionDialog = {
        open: false,
        media: null
      };
    },
    hasActiveWheelTorque(wheelTorques) {
      if (!wheelTorques || !Array.isArray(wheelTorques)) {
        return false;
      }

      const hasActive = wheelTorques.some((wt) => !!wt.active);

      return hasActive;
    },
    formatWheelTorqueDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.toLocaleDateString('pt-BR')} às ${date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
    },
    getWheelTorqueUserInfo(wheelTorque) {
      if (!wheelTorque || !wheelTorque.created_at) {
        return 'VERIFICADO';
      }

      const userName = wheelTorque.user?.name ? wheelTorque.user.name.split(' ')[0].toUpperCase() : 'USUÁRIO';

      const dateInfo = this.formatWheelTorqueDate(wheelTorque.created_at);

      return `${userName} - ${dateInfo}`;
    },
    handleWheelTorqueClick() {
      this.$nextTick(() => {
        if (this.wheel_torque_status) {
          this.$store.dispatch('ServiceOrder/checkWheelTorque');
        } else {
          this.$store.dispatch('ServiceOrder/uncheckWheelTorque');
        }
      });
    },
    deletePhotoInBackup() {
      this.checkBackupMedias(this.service_order);
      this.closeModalBackupPhotos();
    },
    resyncPhotoInBackup(photo, response) {
      if (!photo || !photo.service_order || photo.service_order !== this.currentServiceOrderId) {
        return;
      }

      switch (photo.tag) {
        case 'entry_medias_main':
          this.entry_medias.main = photo;
          break;
        case 'entry_medias_front':
          this.entry_medias.front = photo;
          break;
        case 'entry_medias_rear':
          this.entry_medias.rear = photo;
          break;
        case 'entry_medias_right':
          this.entry_medias.right = photo;
          break;
        case 'entry_medias_left':
          this.entry_medias.left = photo;
          break;
        case 'entry_medias_panel':
          this.entry_medias.panel = photo;
          break;
        case 'entry_medias_secret':
          this.entry_medias.secret = photo;
          break;
        case 'entry_medias_step':
          this.entry_medias.step = photo;
          break;
        case 'entry_medias_chassi':
          this.entry_medias.chassi = photo;
          break;
        case 'entry_medias_motor':
          this.entry_medias.motor = photo;
          break;
        case 'leaving_medias_main':
          this.leaving_medias.main = photo;
          break;
        case 'leaving_medias_front':
          this.leaving_medias.front = photo;
          break;
        case 'leaving_medias_rear':
          this.leaving_medias.rear = photo;
          break;
        case 'leaving_medias_right':
          this.leaving_medias.right = photo;
          break;
        case 'leaving_medias_left':
          this.leaving_medias.left = photo;
          break;
        case 'leaving_medias_panel':
          this.leaving_medias.panel = photo;
          break;
        case 'leaving_medias_chassi':
          this.leaving_medias.chassi = photo;
          break;
        case 'leaving_medias_motor':
          this.leaving_medias.motor = photo;
          break;
        default: {
          const splitted = photo.tag.split('_');
          if (photo.tag.includes('service_medias') && !photo.tag.includes('_second')) {
            this.service_medias.unshift({
              first: { ...photo, id: response.data.created_id, photo_url: photo.photo_url },
              order: splitted[2],
              second: null
            });
          } else if (photo.tag.includes('breakdowns_medias') && !photo.tag.includes('_second')) {
            this.breakdowns_medias.unshift({
              first: { ...photo, id: response.data.created_id, photo_url: photo.photo_url },
              order: splitted[2],
              second: null
            });
          } else if (photo.tag.includes('service_medias') && photo.tag.includes('_second')) {
            const firstPhotoIndex = this.service_medias.findIndex((p) => p.first.tag === `${splitted[0]}_${splitted[1]}_${splitted[2]}`);
            if (firstPhotoIndex !== -1) {
              this.service_medias[firstPhotoIndex].second = { ...photo, id: response.data.created_id, photo_url: photo.photo_url };
            }
          }
          break;
        }
      }

      this.$store.dispatch('ServiceOrder/addMedia', { ...response.data });
    },
    async uploadViaBackend(file, tag, identification, resync = false) {
      const self = this;

      self.setLoading(tag, true);

      try {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('tag', tag);
        formData.append('type', file.type);
        appendMetadataToFormData(formData);

        if (!resync) {
          self.localBackupMedia(file, tag, false);
        }

        const response = await self.$http.post(`/service_order/${self.service_order.id}/photo/create?type=os&tag=${tag}`, formData, {
          timeout: 1000 * 180,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        if (resync) {
          self.$store.dispatch('ServiceOrder/addMedia', {
            id: response.data.created_id,
            created_at: response.data.created_at,
            tag: resync.tag
          });

          if (self.parameterMediaBackupHours) {
            await dexieDB.removeAttempts(resync.id);
          } else {
            await dexieDB.removeServiceOrderPhoto(resync.id);
          }

          const bkpToRemove = self.service_order_pending_photos.findIndex((photo) => photo.id === resync.id);
          if (bkpToRemove !== -1) {
            self.service_order_pending_photos.splice(bkpToRemove, 1);
          }

          if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
            self.$store.dispatch('ServiceOrder/setMediaLoading', false);
          }

          self.resyncPhotoInBackup(resync, response);
        } else {
          self.setMediaId(identification, response.data.created_id, response.data.created_at);
          self.$store.dispatch('ServiceOrder/addMedia', {
            id: response.data.created_id,
            created_at: response.data.created_at,
            tag
          });

          if (self.parameterMediaBackupHours) {
            await dexieDB.removeAttemptsByTag(self.service_order.id, tag);
          } else {
            await dexieDB.removeServiceOrderPhotoByTag(self.service_order.id, tag);
          }
        }

        self.setLoading(tag, false);
      } catch (error) {
        self.setLoading(tag, false);
        throw new Error(`Falha no upload via backend: ${error.message}`);
      }
    },
    async uploadMediaMultipartWithPresignedUrls(file, uploadData, tag, identification, resync) {
      const self = this;

      if (!uploadData || typeof uploadData !== 'object') {
        throw new Error('Dados de upload inválidos recebidos do servidor');
      }

      const { UploadId, Key, partUrls, partSize } = uploadData;

      if (!UploadId || !Key || !Array.isArray(partUrls) || !partSize) {
        console.error('Estrutura de uploadData inválida:', uploadData);
        throw new Error('Estrutura de dados de upload incompleta. Verifique se o backend está retornando UploadId, Key, partUrls (array) e partSize');
      }

      for (let i = 0; i < partUrls.length; i += 1) {
        const partUrl = partUrls[i];
        if (!partUrl || !partUrl.uploadUrl || !partUrl.partNumber) {
          console.error(`Item ${i} do partUrls é inválido:`, partUrl);
          throw new Error(`Item ${i} do partUrls não tem a estrutura esperada (uploadUrl e partNumber necessários)`);
        }
      }

      try {
        const uploadPromises = partUrls.map(async (partUrl) => {
          const start = (partUrl.partNumber - 1) * partSize;
          const end = Math.min(start + partSize, file.size);
          const partData = file.slice(start, end);

          const uploadResponse = await fetch(partUrl.uploadUrl, {
            method: 'PUT',
            body: partData,
            headers: {
              'Content-Length': partData.size.toString()
            }
          });

          if (!uploadResponse.ok) {
            throw new Error(`Erro no upload da parte ${partUrl.partNumber}: ${uploadResponse.status}`);
          }

          const etag = uploadResponse.headers.get('ETag');

          return {
            ETag: etag,
            PartNumber: partUrl.partNumber
          };
        });

        const parts = await Promise.all(uploadPromises);

        parts.sort((a, b) => a.PartNumber - b.PartNumber);

        await self.uploadMediaMultipartFinish(file, parts, tag, identification, Key, UploadId, resync);
      } catch (error) {
        self.setLoading(tag, false);

        if (resync) {
          self.service_order_pending_photos = self.service_order_pending_photos.map((photo) => {
            if (photo.id === resync.id) {
              return { ...photo, loading: false };
            }
            return photo;
          });

          if (self.service_order_pending_photos.length === 0 && self.loading.length === 0) {
            self.$store.dispatch('ServiceOrder/setMediaLoading', false);
          }
        }

        throw new Error(`Falha no upload multipart com URLs pré-assinadas: ${error.message}`);
      }
    },
    async convertHeicToJpeg(fileOriginal) {
      try {
        const isHeicByType =
          fileOriginal.type === 'image/heic' ||
          fileOriginal.type === 'image/heif' ||
          fileOriginal.type === 'image/x-heic' ||
          fileOriginal.type === 'image/x-heif';

        const isHeicByExtension =
          fileOriginal.name && (fileOriginal.name.toLowerCase().endsWith('.heic') || fileOriginal.name.toLowerCase().endsWith('.heif'));

        if (!isHeicByType && !isHeicByExtension) {
          return fileOriginal;
        }

        const convertedBlob = await heic2any({
          blob: fileOriginal,
          quality: 0.8,
          toType: 'image/jpeg'
        });

        const finalBlob = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;

        const convertedFile = new File([finalBlob], `${Date.now()}_converted.jpg`, {
          type: 'image/jpeg'
        });

        return convertedFile;
      } catch (error) {
        console.error('Erro ao converter HEIC:', error);

        this.$toast.warning('Não foi possível converter o arquivo HEIC. Tentando enviar formato original...', {
          position: 'bottom-right',
          duration: 3000
        });

        const fallbackFile = new File([fileOriginal], `${Date.now()}_heic_fallback.jpg`, {
          type: 'image/jpeg'
        });

        return fallbackFile;
      }
    },
    clearBlobUrls() {
      const clearBlobsFromArray = (array) => {
        if (Array.isArray(array)) {
          array.forEach((item) => {
            if (item?.first?.photo_url && item.first.photo_url.includes('blob:')) {
              URL.revokeObjectURL(item.first.photo_url);
            }
            if (item?.second?.photo_url && item.second.photo_url.includes('blob:')) {
              URL.revokeObjectURL(item.second.photo_url);
            }
          });
        }
      };

      const clearBlobsFromObject = (obj) => {
        if (obj && typeof obj === 'object') {
          Object.values(obj).forEach((item) => {
            if (item?.photo_url && item.photo_url.includes('blob:')) {
              URL.revokeObjectURL(item.photo_url);
            }
          });
        }
      };

      clearBlobsFromArray(this.service_medias);
      clearBlobsFromArray(this.breakdowns_medias);
      clearBlobsFromArray(this.service_order_pending_photos);
      clearBlobsFromObject(this.entry_medias);
      clearBlobsFromObject(this.leaving_medias);
    },
    clearServiceOrderState() {
      this.clearBlobUrls();
      this.uploadQueue.clearAll();
      this.service_medias = [];
      this.breakdowns_medias = [];
      this.entry_medias = {
        main: null,
        front: null,
        rear: null,
        right: null,
        left: null,
        panel: null,
        secret: null,
        step: null
      };
      this.leaving_medias = {
        main: null,
        front: null,
        rear: null,
        right: null,
        left: null,
        panel: null
      };
      this.service_order_pending_photos = [];
      this.service_order_backup_photos = [];
      this.attachments = [];
      this.loading = [];
      this.lastProcessedServiceId = null;
      this.entry_order = 0;
      this.breakdowns_order = 0;
      this.wheel_torque_status = false;
    },
    async printOS() {
      this.printLoading = true;
      try {
        const user = this.$store.getters['Auth/user'];
        const organizationUrl = user.organization.organization_parameters.find((parameter) => parameter.code === 'ORGANIZATION_DOMAIN_URL');

        if (!organizationUrl) {
          console.error('URL da organização não encontrada');
          return;
        }

        const pdfUrl = `${organizationUrl.value}/os/${this.service_order.hash}/pasta`;

        const ServiceOrderService = (await import('@/services/api/serviceOrder')).default;
        const response = await ServiceOrderService.generatePDF(pdfUrl);

        if (response.data && response.data.url) {
          window.open(response.data.url, '_blank');
        } else {
          throw new Error('URL do PDF não retornada pelo servidor');
        }
      } catch (error) {
        console.error('Erro ao gerar PDF para impressão:', error);
      } finally {
        this.printLoading = false;
      }
    },
    organizeMediasBySections() {
      if (this.isOrganizing) return;

      this.sections = [];

      this.isOrganizing = true;

      try {
        SECTION_CONFIGS.forEach((sectionConfig) => {
          const section = this.service_order?.service_order_photo_sections.find((s) => s.tag === sectionConfig.tag);

          if (!section) {
            this.sections.push({
              tag: sectionConfig.tag,
              description: sectionConfig.description ?? '',
              supportsPairs: sectionConfig.supportsPairs,
              items: [],
              lastOrder: 0,
              checked: true
            });
            return;
          }

          this.sections.push({
            tag: section.tag,
            description: section.description ?? '',
            supportsPairs: true,
            items: [],
            lastOrder: 0,
            checked: true,
            createdAt: section.created_at,
            updatedAt: section.updated_at
          });
        });

        this.service_order.service_order_photo_sections.forEach((sectionData) => {
          const isInSection = this.sections.find((s) => s.tag === sectionData.tag);

          if (isInSection) return;

          this.sections.push({
            tag: sectionData.tag,
            description: sectionData.description ?? '',
            supportsPairs: true,
            items: [],
            lastOrder: 0,
            id: sectionData.id,
            order: sectionData.order || sectionData.sort_order || null,
            active: sectionData.active ?? 1,
            checked: sectionData.checked || false,
            createdAt: sectionData.created_at,
            updatedAt: sectionData.updated_at
          });
        });

        this.sections.sort((a, b) => {
          if (a.order === null && b.order === null) return 0;
          if (a.order === null) return 1;
          if (b.order === null) return -1;
          return a.order - b.order;
        });

        this.service_order.service_order_photos.forEach((media) => {
          const tagSplitted = media.tag.split('_');

          const isSecond = tagSplitted?.[tagSplitted.length - 1] === 'second';

          const tagArray = tagSplitted.splice(0, isSecond ? tagSplitted.length - 2 : tagSplitted.length - 1);
          const tagSection = tagArray.join('_');

          const mediaOrder = Number(tagSplitted[0]);

          const section = this.sections.find((s) => s.tag === tagSection);

          if (!section) return;

          const mediaObj = {
            id: media.id,
            tag: media.tag,
            src: media.photo_url,
            observation: media.observation,
            createdAt: media.created_at,
            type: media.type,
            visible: media.visible
          };

          let itemSection = section.items.find(({ order }) => order === mediaOrder);
          if (!itemSection) {
            itemSection = {
              order: mediaOrder,
              [isSecond ? 'second' : 'first']: mediaObj,
              [isSecond ? 'first' : 'second']: null
            };
            section.items.push(itemSection);
            return;
          }

          itemSection[isSecond ? 'second' : 'first'] = mediaObj;
        });

        this.sections = this.sections.map((sec) => {
          const items = sec.items.sort((a, b) => b.order - a.order);
          return {
            ...sec,
            items
          };
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.isOrganizing = false;
      }
    },
    createSections(sections) {
      return sections
        .reduce((chain, section) => {
          const isObject = typeof section === 'object';
          const description = isObject ? section.description : section;
          const order = isObject ? section.order : null;

          const tag = description
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '_')
            .trim();

          const uniqueTag = `${tag}_${Date.now()}`;

          const sectionData = {
            service_order_id: this.service_order.id,
            tag: uniqueTag,
            description,
            ...(order !== null && { order, sort_order: order })
          };

          return chain.then(() => this.$store.dispatch('ServiceOrder/addSection', sectionData));
        }, Promise.resolve())
        .then(() => {
          this.organizeMediasBySections();
        });
    },
    async saveModalAddSection({ sections }) {
      this.modalAddSection.loading = true;

      try {
        await this.createSections(sections);
        this.modalAddSection.isOpen = false;
      } finally {
        this.modalAddSection.loading = false;
      }
    },
    async addFixedSections() {
      this.$store.dispatch('ServiceOrder/setLoading', true);

      try {
        await this.$store.dispatch('ServiceOrder/bulkCreateSections');
        this.organizeMediasBySections();
      } catch (error) {
        console.error('Erro ao carregar seções fixas:', error);
      } finally {
        this.$store.dispatch('ServiceOrder/setLoading', false);
      }
    },
    async uploadMediaMediaSection(file, tag, options) {
      await this.uploadMedia(file, tag, options);
    },
    addOrderLoading(order) {
      this.ordersLoading.push(order);
    }
  },
  watch: {
    'confirm_delete.opened': {
      handler(val) {
        if (!val) {
          this.confirm_delete = {
            opened: false,
            component: null,
            second: null,
            index: null
          };
        }
      }
    },

    service_order_pending_photos: {
      handler(val) {
        if (val.length === 0) {
          this.$emit('reset-pending-medias', this.service_order.id);
        }
      }
    },

    wheel_torque: {
      handler(newVal) {
        this.wheel_torque_status = this.hasActiveWheelTorque(newVal);
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style lang="scss">
.service-photos {
  padding: 4px;

  .truck-thumbnail-container {
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
    color: rgba(0, 0, 0, 0.28) !important;
  }

  .uploading-photos {
    height: 39px;
    margin-top: 10px;
    background-color: red;
    border-radius: 5px;
    border: 2px solid #c30000;
    background-color: #ff0000;
    color: #fff;
    font-size: 13px;
    padding-top: 8px;
    text-align: center;
  }

  .upload-queue-status {
    color: #333;
    background-color: #e3f2fd;
    border: 2px solid #2196f3;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 10px;

    .uqs-header {
      text-align: center;
      text-transform: uppercase;
      margin-bottom: 10px;
      padding-bottom: 6px;
      border-bottom: 1px solid #2196f3;
      font-size: 14px;
      font-weight: bold;
    }

    .uqs-info {
      margin-bottom: 10px;
      text-align: center;
    }

    .uqs-upload {
      margin-bottom: 8px;
      padding: 8px;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #ddd;

      .uqs-upload-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
        font-size: 12px;

        .uqs-tag {
          font-weight: bold;
          color: #1976d2;
        }

        .uqs-status {
          color: #666;
          text-transform: uppercase;
        }
      }
    }

    .uqs-retry {
      margin-bottom: 8px;
      padding: 8px;
      background-color: #fff3e0;
      border-radius: 4px;
      border: 1px solid #ff9800;

      .uqs-retry-info {
        display: flex;
        justify-content: space-between;
        margin-bottom: 4px;
        font-size: 12px;

        .uqs-tag {
          font-weight: bold;
          color: #f57c00;
        }

        .uqs-retry-count {
          color: #e65100;
          font-weight: bold;
        }
      }

      .uqs-retry-time {
        font-size: 11px;
        color: #bf360c;
        text-align: center;
      }
    }
  }

  .pending-photos {
    color: #fff;
    background-color: #e57373;
    border: 3px solid red !important;
    border-radius: 6px;
    padding: 6px;

    .pp-header {
      text-align: center;
      text-transform: uppercase;
      margin-bottom: 10px;
      padding-bottom: 6px;
      padding-top: 4px;
      border-bottom: 1px solid #fff;
    }

    .pp-media {
      margin-bottom: 10px;
      position: relative;
    }

    .resync-image {
      background-color: #fff;
      border-radius: 50%;
      position: absolute !important;
      right: 6px;
      top: 4px;
      margin: 0;
      padding: 6px;
      font-size: 24px !important;
      z-index: 99;
    }

    .remove-image {
      background-color: #fff;
      border-radius: 50%;
      position: absolute !important;
      left: 6px;
      top: 4px;
      width: 36px;
      margin: 0;
      padding: 6px;
      font-size: 24px !important;
      z-index: 99;
    }

    .download-image {
      background-color: #fff;
      border-radius: 50%;
      position: absolute !important;
      right: 6px;
      top: 56px;
      margin: 0;
      padding: 6px;
      font-size: 24px !important;
      z-index: 99;
    }
  }

  .box {
    position: relative;
    overflow: hidden;

    &.h-center {
      height: 100%;

      .add {
        height: 100%;

        i {
          top: 50%;
          font-size: 40px;
          -ms-transform: translateY(-50%);
          transform: translateY(-50%);
        }
      }
    }
  }

  .image-info {
    background-color: #000;
    color: #fff;
    font-size: 12px;
    text-align: center;
    position: absolute;
    width: 100%;
    bottom: 0px;
    border-bottom-right-radius: 5px;
    border-bottom-left-radius: 5px;
  }

  .input-upload {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 98;
  }

  .fileinput {
    display: none;
  }

  .remove-image {
    background-color: #fff;
    border-radius: 50%;
    position: absolute !important;
    right: 10px;
    margin: 10px;
    padding: 6px;
    font-size: 24px !important;
    z-index: 99;
  }

  .edit-observations {
    background-color: #fff;
    border-radius: 50%;
    position: absolute !important;
    left: 10px;
    margin: 10px;
    padding: 0px 6px;
    font-size: 24px !important;
    z-index: 99;
    height: 36px;
    width: 36px;
  }

  .viewer-preview-helper {
    width: -webkit-fill-available;
    height: -webkit-fill-available;
    position: absolute;
    opacity: 0;
    margin: 0 auto;
    z-index: 50;
    overflow: hidden;
  }

  .col {
    position: relative;
    overflow: hidden;
    padding: 6px;
  }

  .v-image {
    border: 1px solid #c3c3c3;
    border-radius: 5px;
    text-align: center;
    color: #756f6f;
    font-size: 13px;
    overflow: hidden;

    span {
      text-transform: uppercase;
    }
  }

  .secret-image {
    border: 1px solid #c3c3c3;
    border-radius: 5px;
    color: #756f6f;
    text-align: center;
    font-size: 13px;
    overflow: hidden;
    padding-top: 10px;
    padding-bottom: 5px;

    img {
      filter: grayscale(100%);
      opacity: 0.9;
      width: 100%;
      max-width: 180px;
      max-height: 120px;
      object-fit: contain;
      padding: 18px;
      display: block;
      margin: 0 auto;
    }
  }

  .step-image {
    border: 1px solid #c3c3c3;
    border-radius: 5px;
    color: #756f6f;
    text-align: center;
    font-size: 13px;
    overflow: hidden;
    padding-top: 10px;
    padding-bottom: 5px;

    img {
      filter: grayscale(100%);
      opacity: 0.9;
      width: 100%;
      max-width: 180px;
      max-height: 120px;
      object-fit: contain;
      padding: 18px;
      display: block;
      margin: 0 auto;
    }
  }

  .opacity .v-image__image {
    opacity: 0.7;
  }

  .checklists-tabs {
    border-radius: 8px;
    background-color: #eee;
    padding: 8px;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
  }

  .check-torque {
    border-radius: 8px;
    background-color: #eee;
    padding: 10px;
    width: -webkit-fill-available;
    margin: 0px 6px;
    margin-bottom: 8px;
    overflow: hidden;

    .v-icon {
      font-size: 30px;
    }
  }

  .tab-switch {
    position: relative;
  }

  .tab-switch.left:after {
    left: 0;
  }

  .tab-switch.right:after {
    left: 50%;
  }

  .tab-switch .tab {
    display: inline-block;
    width: 50%;
    padding: 12px 0;
    z-index: 1;
    position: relative;
    cursor: pointer;
    transition: color 200ms;
    font-size: 15px;
    font-weight: bold;
    line-height: normal;
    user-select: none;
    text-transform: uppercase;
  }

  .tab-switch .tab.active {
    color: #ffffff;
    background-color: #48b38b;
    border-radius: 8.5px;
  }
}

.voice-recognition {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;

  &.recording {
    color: #fff;
    background-color: #48b38b;
    border-color: #48b38b;
  }
}

.photos-container {
  width: 100%;
  padding: 0 6px;

  .panel-title {
    padding-bottom: 16px;
  }

  .photos-grid {
    width: 100%;

    .v-expansion-panel {
      background-color: #f5f5f5;

      &:not(:last-child) {
        border-bottom: 1px solid #ddd;
      }

      .v-expansion-panel-text__wrapper {
        border-top: 1px solid #ddd;
        padding: 10px;
      }

      .v-expansion-panel-title {
        padding: 0px;
        background-color: #f4f4f4;
        padding: 0px 10px;
      }
    }

    .add-section {
      background-color: #f4f4f4;
      color: #767676;
      border: 2px dashed #dddddd;
      padding: 10px 20px;
      border-radius: 4px;
      width: 100%;
      font-size: 14px;
      text-align: center;
      cursor: pointer;
      margin-top: 10px;
    }
  }
}
</style>
